// src/i18n/he.ts
// ============================================================================
// Hebrew UI Copy — FULL SSOT (extracted from core.ts)
// Text only — NO logic, NO URLs, NO React
// ============================================================================

export const he = {
  meta: {
    lang: 'he',
    langFull: 'he-IL',
    dir: 'rtl' as const,
    name: 'עברית',
  },

  // ─────────────────────────────────────────────────────────────
  // WORDS
  // ─────────────────────────────────────────────────────────────

  words: {
    dj: {
      he: `דיג׳יי`,
      he_alt: `די ג׳יי`,
      he_plain: `דיגיי`,
      en: `DJ`,
    },
    music: 'מוזיקה',   

    mc: `תקליטן`,

    events: {
      wedding: { one: `חתונה`, many: `חתונות`, to: `לחתונה` },
      henna: { one: `חינה`, many: `חינות`, to: `לחינה` },
      bar_bat: { one: `בר/בת מצווה`, many: `בר/בת מצוות`, to: `לבר/בת מצווה` },
      generic: { one: `אירוע`, many: `אירועים`, to: `לאירוע` },
    },

    albums: {
      forum: `פורום`,
      articles: `כתבות`,
      recommendations: `המלצות`,
      bars: `ברים`,
      flyers: `פלאיירים`,
    },

    phrases: {
      music_for_events: `מוזיקה לאירועים`,
      company_or_private: `חברה / פרטי`,
    },
  },

  business: {
    name: 'די ג׳יי אליאור מור - מוזיקה לאירועים',
  
    address: {
      street: 'מבצע יואב 16',
      city: 'באר שבע',
      postal: '8445914',
      country: 'IL',
    },
  },

  // ─────────────────────────────────────────────────────────────
  // BRAND
  // ─────────────────────────────────────────────────────────────

  brand: {
    firstName: `אליאור`,
    short: `אליאור מור`,
    title: `די ג׳יי אליאור מור`,
  },

  metaDescription: {
    wedding:
      'מעל 15 שנות ניסיון בחתונות: פסקול אישי, קריאת קהל חדה, מיקסים מדויקים ושילוב סגנונות, רחבה מלאה לאורך כל החתונה – דיג׳יי לחתונה – מקצועי ומומלץ',
  
    henna:
      'מעל 15 שנות ניסיון בחינות: שילוב מסורת, דרבוקות ומוזיקה עדכנית, אווירה צבעונית ורחבה מלאה לאורך כל החינה – דיג׳יי לחינה – מקצועי ומומלץ',
  
    barBat:
      'מעל 15 שנות ניסיון באירועי בר/בת מצווה: כניסה מרגשת, להיטים שהנוער והמבוגרים אוהבים ורחבה מלאה מהשיר הראשון עד האחרון – דיג׳יי לבר/בת מצווה – מקצועי ומומלץ',
  
    generic:
      'מעל 15 שנות ניסיון באירועים: בניית קו מוזיקלי, קריאת קהל חדה ושילוב סגנונות, רחבה מלאה לאורך כל האירוע – דיג׳יי לאירוע – מקצועי ומומלץ',
  },

  // ─────────────────────────────────────────────────────────────
  // HOME
  // ─────────────────────────────────────────────────────────────

  home: {
    title: `מוזיקה לאירועים | די ג׳יי אליאור מור`,

    description:
      `אליאור מור – די ג׳יי עם מעל 15 שנות ניסיון בחתונות, חינות, בר/בת מצווה ואירועים. ` +
      `קריאת קהל חדה, שילוב סגנונות ומיקסים מדוייקים שיוצרים רחבה מלאה וחוויה מוזיקלית בלתי נשכחת.`,

    heroTitle: `אליאור מור – מוזיקה לאירועים`,


    sections: {
      section1Lines: (
        eventOne: string,
        mcLabel: string,
        brandTitle: string
      ) => [
        `מעל 15 שנות ניסיון שמבטיחות ${eventOne} מושלם`,
        'מוזיקה מדויקת וקריאת קהל חדה',
        'סאונד מקצועי ומיקסים מושלמים',
        `${eventOne} עם וייב שמח ואנרגטי`,
        `פלייליסט שמתאים בדיוק ל${eventOne} שלכם`,
        'חוויה מוזיקלית שלא שוכחים',
        `${brandTitle} - ${mcLabel} ל${eventOne} מושלם`,
      ],
    
      section2DescriptionSuffix: (eventOne: string) =>
        `כדי שכל ${eventOne} יהפוך לחוויה בלתי-נשכחת שהאורחים ידברו עליה עוד הרבה אחרי.`,
    
      section2AdditionalSuffix: '',
    
      section5SubtitleDesktop: (
        weddingOne: string,
        hennaOne: string,
        barBatOne: string,
        genericOne: string
      ) =>
        `בין אם זו ${weddingOne}, ${hennaOne}, ${barBatOne} או כל ${genericOne} אחר – אני מתאים את המוזיקה לאופי הקהל ולאווירה שאתם רוצים ליצור. עם תזמון מדויק, קריאת קהל חדה ושילוב חכם בין סגנונות, הערב זורם בקצב נכון שמרים את האנרגיות ומשאיר את הרחבה מלאה. בזכות שנים של ניסיון מול קהלים מגוונים, אני יוצר רצף מוזיקלי טבעי, מרגש ומחבר – מהצליל הראשון ועד האחרון.`,
    
      section5SubtitleMobile: (
        weddingMany: string,
        hennaMany: string,
        barBatOne: string,
        genericMany: string,
        genericOne: string
      ) =>
        `${weddingMany}, ${hennaMany}, ${barBatOne} ו${genericMany} עסקיים – אני מתאים את המוזיקה לקהל שלכם ומרים רחבה מלאה ושמחה עד סוף ה${genericOne}.`,
    
      section6Title: (brandTitle: string) =>
        `ביקורות והמלצות על ${brandTitle}`,
    
      section6Subtitle: (genericOne: string) =>
        `מה לקוחות מספרים על החוויה איתי ברחבה? ביקורות אמיתיות על המוזיקה, האנרגיה והליווי מהשיחה הראשונה ועד סוף ה${genericOne}.`,
    },
  },
  // ─────────────────────────────────────────────────────────────
  // SECTION 1 — OPEN
  // ────────────────────────────────────────────────────────────

  section1: {  
    targetPageLines: {
      base: [
        'יותר מ־15 שנות ניסיון בכל סוגי האירועים',
        'מוזיקה שנבנית לפי הקצב של הקהל שלכם',
        'קריאת קהל מדויקת ואווירה שעושה חשק לרקוד',
        'רחבה מלאה ושמחה שנמשכת עד השעות הקטנות',
      ],
    
      wedding: [
        'מעל 15 שנות ניסיון בחתונות',
        'מוזיקה מדויקת לכל רגע בחתונה',
        'בניית פסקול אישי שמותאם בדיוק אליכם',
        'מיקסים מושלמים וקריאת קהל חדה',
        'ליווי מקצועי ותכנון מוזיקלי מלא',
        'חתונה שהאורחים לא מפסיקים לדבר עליה',
      ],
    
      henna: [
        'חינה מרגשת עם וייב אותנטי',
        'אווירה צבעונית שמחה וחגיגית',
        'שילוב מושלם של מסורת ומודרניות',
        'דרבוקות ומקצבים שמרימים את כל המשפחה',
        'פלייליסט שמתאים בדיוק לחינה שלכם',
        'טקס חינה מרגש עם אווירה מחשמלת',
      ],
    
      bar_bat: [
        'מעל 15 שנות ניסיון בבר/בת מצוות',
        'כניסה מרגשת שהאורחים לא שוכחים',
        'רחבה מלאה מהשיר הראשון עד האחרון',
        'להיטים עדכניים שהנוער והמבוגרים אוהבים',
        'אווירה משפחתית ושמחה',
        'חוויה מוזיקלית שנשארת בזיכרון',
      ],
    
      event: [
        'מעל 15 שנות ניסיון בכל סוגי האירועים',
        'מוזיקה מדויקת וקריאת קהל חדה',
        'סאונד מקצועי ומיקסים מושלמים',
        'אירוע עם וייב שמח ואנרגטי',
        'פלייליסט שמתאים בדיוק לאירוע שלכם',
        'חוויה מוזיקלית שלא שוכחים',
      ],
    },
    hub: {
      city: {
        descriptionLines: (
          keyword: string,
          cityBet: string,
          brandTitle: string
        ) => [
          '15 שנות ניסיון שמדברות מעצמן',
          'מוזיקה שמתאימה לכל סגנון של קהל',
          'יודע להרגיש את הרחבה ולתת את השיר הנכון',
          'אווירה שמחה מתחילת האירוע ועד הסוף',
          `${brandTitle} – ${keyword}${cityBet}`,
        ],
    
        extraHeadings: (keyword: string, cityBet: string) => [
          `איך לבחור ${keyword}${cityBet} בצורה נכונה`,
          `סוגי אירועים פופולריים${cityBet}`,
        ],
      },
    
      region: {
        descriptionLines: (
          keyword: string,
          regionBet: string,
          brandTitle: string
        ) => [
          'יותר מ־15 שנות ניסיון שמדברים בעד עצמם',
          'מוזיקה מגוונת שמתאימה לכל סוג קהל',
          'רחבת ריקודים שמלאה באנרגיה ושמחה',
          'אווירה חגיגית שנמשכת כל הערב',
          `${brandTitle} – ${keyword}${regionBet}`,
        ],
    
        extraHeadings: (keyword: string, regionBet: string) => [
          `איך לבחור ${keyword}${regionBet}`,
          `ערים מובילות${regionBet} להתחלת החיפוש`,
        ],
      },
    
      home: {
        section1Lines: (eventOne: string, mcLabel: string, brandTitle: string) => [
          `מעל 15 שנות ניסיון שמבטיחות ${eventOne} מושלם`,
          'מוזיקה מדויקת וקריאת קהל חדה',
          'סאונד מקצועי ומיקסים מושלמים',
          `${eventOne} עם וייב שמח ואנרגטי`,
          `פלייליסט שמתאים בדיוק ל${eventOne} שלכם`,
          'חוויה מוזיקלית שלא שוכחים',
          `${brandTitle} - ${mcLabel} ל${eventOne} מושלם`,
        ],
      },
    },
  },
  // ─────────────────────────────────────────────────────────────
  // SECTION 2 — ABOUT
  // ─────────────────────────────────────────────────────────────

  section2: {
    title: 'הסיפור שלי',

    description:
      `עם ניסיון של מעל 15 שנים על עמדת הדי ג׳יי, כולל עשור כתקליטן הבית במועדון הפורום – אני אליאור מור, דיג׳יי שמוביל את הערב בקצב הנכון ויוצר רגעים בלתי נשכחים. בכל אירוע אני מביא אנרגיה מחשמלת, קריאת קהל חדה, מיקסים מדויקים ומוזיקה שמרימה את הרחבה מהשיר הראשון ועד האחרון`,

    additionalText:
      'כל אירוע מבחינתי הוא הזדמנות להרים את הרחבה וליצור רגעים שאנשים זוכרים. המטרה שלי – לוודא שהאורחים נהנים מהאירוע מתחילתו ועד סופו. אני מחבר בין סגנונות, קורא את הקהל ומפתיע עם קטעים שלא שמעתם שנים. וזה מה שהופך את האירוע שלכם לחוויה שמרגישה ברמה אחרת.',

    imageAltPortrait: `אליאור מור על העמדה`,
    imageAltHorizontal: `אליאור מור – די ג׳יי שיודע להרים מסיבה`,

    targetAdditionalByService: {
      wedding:
        'חתונה היא סיפור אהבה שמקבל חיים דרך המוזיקה. חשוב לי קודם כל להכיר אתכם באמת – להבין מי אתם, מה מרגש אתכם ואיך אתם מדמיינים את החתונה שלכם. מתוך ההיכרות הזאת אנחנו בונים יחד פסקול אישי, מדייקים כל רגע ומעצבים יחד את האווירה, כדי להפוך את החלום שלכם למציאות ולחגיגה בלתי נשכחת מהצליל הראשון ועד שיר הסיום.',
    
      henna:
        'כל חינה היא חגיגה צבעונית שאני בונה בקפידה מהרגע הראשון. המטרה שלי פשוטה – אווירה שמחה, קצב שמרים את כולם ורחבה מלאה. אני משלב בין מסורת לקצב עכשווי ויוצר זרימה שלא נותנת לאורחים לשבת.',
    
      bar_bat:
        'כל בר/בת מצווה היא הזדמנות לייצר רגעים מיוחדים שמחברים בין כולם. המטרה שלי פשוטה – ליצור מסיבה שמרגישה טבעית לנוער וגם למבוגרים. עם שילוב נכון של שירים עדכניים וקלאסיקות אהובות, נוצרת חגיגה צעירה וסוחפת שכולם מרגישים חלק ממנה.',
    
      event:
        'כל אירוע הוא הזדמנות ליצור חוויה מוזיקלית מדויקת שמותאמת לקהל ולאופי האירוע. בעזרת קריאת קהל בזמן אמת, מעברים מוזיקליים חלקים ושילוב נכון בין סגנונות, נוצרת אווירה שמרימה את הרחבה ושומרת על אנרגיה גבוהה לאורך כל הערב. כך כל אירוע הופך לחגיגה שהאורחים זוכרים עוד הרבה אחרי שהאירוע מסתיים.',
    },
    
    targetAdditionalSuffixByService: {
      wedding:
        'אני מעניק לחתונה שלכם נגיעה אישית ודיוק שמורגש בכל רגע.',
    
      henna:
        'אני מוסיף לחינה שלכם טאצ׳ מיוחד שהופך אותה לאירוע מלא חיים.',
    
      bar_bat:
        'אני בונה לאירוע שלכם זהות מוזיקלית שמתאימה בדיוק למשפחה ולווייב שאתם רוצים ליצור.',
    
      event:
        'אני מדייק את המוזיקה כך שכל אירוע יקבל את האופי המיוחד שלו.',
    },

    fallbackSuffix:
   'כך האירוע שלכם מקבל וייב שמתאים בדיוק לקהל שלכם.',

    targetDescription: (
      baseDescription: string,
      djKeyword: string,
      cityBet: string
    ) => {
      if (!String(cityBet ?? '').trim()) {
        return `${baseDescription} אני ${djKeyword}, עם ניסיון רחב באירועים, התאמה אישית לקהל ויכולת לקרוא את הרחבה בזמן אמת.`;
      }

      return `${baseDescription} אני ${djKeyword}${cityBet}, עם היכרות מעולה עם הקהל המקומי והאולמות באזור.`;
    },

      targetAdditionalText: (
        base: string,
        cityBet: string,
        suffix: string
      ) => `${base} ${cityBet} ${suffix}`.replace(/\s+/g, ' ').trim(),
  },

  // ─────────────────────────────────────────────────────────────
  // SECTION 3 — GALLERY
  // ─────────────────────────────────────────────────────────────

  section3: {
    title: 'תנו לתמונות לדבר',
    fallbackText: 'בחר אלבום כדי לראות פרטים נוספים',
    albumsError: 'לא ניתן לטעון אלבומים. נסו שוב מאוחר יותר.',
    filesError: 'שגיאה בטעינת הקבצים.',
    loading: 'טוען גלריה…',

    galleryHeadings: {
      wedding: (keyword: string, cityBet: string) => [
        `תמונות מ${keyword}${cityBet} – חופה, סלואו ורחבה`,
        `רגעים מחתונות${cityBet} – אנרגיה על הרחבה`,
        `זוגות מאושרים וסטים בוערים – חתונות${cityBet}`,
      ],
    
      henna: (_keyword: string, cityBet: string) => [
        `גלריית חינה${cityBet} – צבע, מעגלים וקצב`,
        `מסורת ושמחה – חינות${cityBet} בתמונות`,
        `דרבוקות ואנרגיה – חינה${cityBet} ברגעים אמיתיים`,
      ],
    
      bar_bat: (_keyword: string, cityBet: string) => [
        `בר/בת מצווה${cityBet} – כניסה, רחבה ואווירה`,
        `נוער ומשפחה רוקדים – בר/בת מצווה${cityBet}`,
        `שיאים ותמונות חיות – בר/בת מצווה${cityBet}`,
      ],
    
      event: (_keyword: string, cityBet: string) => [
        `היילייטס מאירועים${cityBet} – רחבות מלאות`,
        `סטייל מוזיקלי ואנרגיה – אירועים${cityBet}`,
        `גלריית אירועים${cityBet} – רגעים שלא שוכחים`,
      ],
    },

    albumDescriptions: {
      weddings:
        'תמונות מתוך חתונות אמיתיות – חופה, סלואו ורחבה בוערת. וייב שמרים את כל האורחים מהרגע הראשון ועד האחרון.',

      hennas:
        'צבע, תופים ומעגלים – חינות מלאות אנרגיה ושמחה עם שילוב מושלם בין מסורת לוייב עכשווי.',

      barBat:
        'רגעים מבר/בת מצוות – כניסת מצווה, רחבת נוער ומשפחה, ואווירה מחשמלת שמחברת את כולם.',

      forum:
        'סטים מחשמלים ממועדון הפורום באר שבע, שם שימשתי כרזידנט עשור. אווירה של 3,000 חוגגים בכל סוף שבוע.',

      articles:
        'אוסף כתבות, ראיונות וסיקורים תקשורתיים – הסיפורים והאירועים שמאחורי המוזיקה.',

      recommendations:
        'טסטימוניאלס אמיתיים מלקוחות – פידבקים, הודעות ומכתבי תודה אחרי לילות בלתי נשכחים.',

      bars:
        'סטים מברים ומקומות בילוי ברחבי הארץ – מוזיקה מדויקת לקהל וערבים מלאי אנרגיה.',

      flyers:
        'אוסף הפלאיירים מערבי מועדונים ואירועים – כל אחד מספר סיפור של לילה חם במיוחד.',
    },

    albumTexts: {
      weddings:
        'מעבר למוזיקה עצמה, חשוב לי ללוות אתכם לחתונה לאורך כל הדרך. אני מביא איתי ניסיון של מאות זוגות מרוצים, ראייה רחבה של החתונה ותשומת לב לפרטים הקטנים שעושים את ההבדל. המטרה שלי היא לתת לכם שקט נפשי, ביטחון מקצועי וידיעה שיש מי שמוביל את החתונה בצורה מדויקת.',

      forum:
        'פורום באר שבע – מועדון ברמה בינלאומית שבו שימשתי כרזידנט במשך 10 שנים, עם סטים מחשמלים מול 3,000 חוגגים בכל סוף שבוע. מוזיקה עדכנית, אפקטים עוצמתיים ואווירה שאין כמוה בישראל',

      articles:
        'אוסף כתבות שהתפרסמו עליי במדיה הארצית והמקומית, הכוללות ראיונות, סיפורים ותיעוד אירועים מיוחדים בהם השתתפתי, ומשקפות את הדרך והעשייה המוזיקלית שלי לאורך השנים',

      hennas:
        'חינות הן השילוב המושלם בין מסורת, צבע ושמחה מתפרצת. עם מוזיקה אותנטית, תופים מרעידים ואנרגיות שמרימות את האולם, אני יוצר חוויית חינה עוצמתית ובלתי נשכחת. ניסיון של שנים בהובלת אירועי חינה מבטיח שכל האורחים, צעירים ומבוגרים, יישארו על הרגליים וירקדו עד הרגע האחרון',

      recommendations:
        'דברי תודה והמלצות מלקוחות שחוו איתי אירועים מרגשים ומלאי אנרגיה. כל מכתב וכל הודעה הם עדות לאהבה ולחוויות שיצרנו יחד',

      barBat:
        'בר/בת מצווה הוא אירוע של פעם בחיים – ואני כאן כדי להפוך אותו לחגיגה אמיתית. שילוב מנצח של מוזיקה עדכנית עם להיטים על-זמניים, הפעלות מגניבות ואווירה מחשמלת. עם ניסיון עשיר בניהול אירועי בר/בת מצווה, אני מבטיח שכל האורחים, מהחבר׳ה של החוגג/ת ועד הסבא והסבתא, ייהנו מרגעים שייזכרו לנצח',

      bars:
        'במהלך הקריירה ניגנתי במגוון ברים ומקומות בילוי בכל רחבי הארץ. לכל מקום הבאתי את הסאונד והווייב הייחודי שלי, עם מוזיקה שמתאימה בדיוק לקהל ומייצרת אווירה מושלמת לבילוי',

      flyers:
        'אוסף הפלאיירים של המקומות בהם הופעתי – מהפורום בבאר שבע ועד ברים ואולמות בכל הארץ. כל פלאייר מספר את סיפורו של ערב מלא במוזיקה, אנשים ואנרגיות שבלתי אפשר לשכוח',
    },
  },

  // ─────────────────────────────────────────────────────────────
  // SECTION 4 — CONTACT / CTA
  // ─────────────────────────────────────────────────────────────

  section4: {
    title: 'שדרג את האירוע שלך',

    description:
      'מחפש/ת די ג׳יי לאירוע שלך?\nכאן תמצאו את השילוב המנצח של ניסיון, אנרגיה ומוזיקה',

    groupTitles: {
      contact: 'יצירת קשר',
      events: 'קטגוריות אירועים',
      services: 'שירותים נוספים',
    },

    eventsIntro: {
      default: `מוזיקה מותאמת לכל סגנון אירוע, פרטי או עסקי.`,
  
      wedding: (keyword: string, cityBet: string) =>
        `${keyword}${cityBet} – מהחופה ועד המסיבה, מוזיקה שמדויקת לכם ולאורחים.`,
  
      henna: (keyword: string, cityBet: string) =>
        `${keyword}${cityBet} – שילוב של מקצבים מסורתיים וביטים עכשוויים, חגיגה צבעונית לכל המשפחה.`,
  
      bar_bat: (keyword: string, cityBet: string) =>
        `${keyword}${cityBet} – להיטים עדכניים לצד קלאסיקות שכל הדורות נהנים מהם.`,
  
      event: (keyword: string, cityBet: string) =>
        `${keyword}${cityBet} – מוזיקה מותאמת לכל סגנון אירוע, פרטי או עסקי.`,
    },

    servicesIntro: {
      wedding: (_keyword: string, cityBet: string) =>
        `תוספות לחתונות${cityBet}: תאורה לחתונה, הגברה מקצועית ואטרקציות לחתונה.`,
    
      henna: (_keyword: string, cityBet: string) =>
        `תוספות לחינות${cityBet}: דרבוקות לחינה, תאורה חמה ואטרקציות לחינה.`,
    
      bar_bat: (_keyword: string, cityBet: string) =>
        `תוספות לבר/בת מצוות${cityBet}: תאורה לבר/בת מצווה, סאונד איכותי ואטרקציות לבר/בת מצווה.`,
    
      event: (_keyword: string, cityBet: string) =>
        `תוספות לאירועים${cityBet}: תאורה, סאונד ואטרקציות מותאמות לכל סוג אירוע.`,
    },

    blockCopy: {
      withCity: (
        keyword: string,
        cityName: string,
        firstName: string
      ) => ({
        description:
          `מחפש/ת ${keyword} ב${cityName}?\nכאן תמצאו את השילוב המנצח של ניסיון, אנרגיה ומוזיקה.`,
    
        whatsappPrefill:
          `שלום ${firstName}, מעוניין/ת ב${keyword} ב${cityName}`,
    
        linksHeading:
          `עמודים קשורים ל${keyword} ב${cityName}`,
      }),
    
      withoutCity: (
        keyword: string,
        eventName: string,
        firstName: string
      ) => ({
        description:
          `מחפש/ת ${keyword} ל${eventName} שלך?\nכאן תמצאו את השילוב המנצח של ניסיון, אנרגיה ומוזיקה.`,
    
        whatsappPrefill:
          `שלום ${firstName}, מעוניין/ת ב${keyword} ל${eventName} שלי`,
    
        linksHeading:
          `עמודים קשורים ל${keyword}`,
      }),
    },
  
    contactSeo: {
      phone: `דברו איתי בטלפון – אשמח לענות על כל שאלה.`,
      whatsapp: `כתבו לי בוואטסאפ ותוך רגעים אחזור עם פרטים.`,
      email: `אפשר גם במייל – שלחו הודעה ואחזור אליכם בהקדם.`,
      instagram: `תציצו באינסטגרם – סרטונים ותמונות חיות מהרחבה.`,
      facebook: `בפייסבוק תמצאו המלצות וקטעים מאירועים אמיתיים.`,
      navigate: `קל להגיע – לחצו לנווט אליי ב-Google Maps.`,
    },

    contactButtons: {
      phone: 'שיחה',
      whatsapp: 'וואטסאפ',
      email: 'אימייל',
      instagram: 'אינסטגרם',
      facebook: 'פייסבוק',
      navigate: 'נווט אליי',
    },

 
      services: {
        sound: {
          label: 'הגברה',
          description: 'הגברה מקצועית – סאונד נקי וברור בכל חלל.',
        },
        light: {
          label: 'תאורה',
          description: 'תאורה דינמית – הופכת כל רחבה למשהו מיוחד.',
        },
        attractions: {
          label: 'אטרקציות',
          description: 'אטרקציות לאירוע – קונפטי, עשן כבד, בלונים ועוד.',
        },
        recording: {
          label: 'הקלטות',
          description: 'שירותי הקלטה – שיר סלואו, ברכות או כניסה מיוחדת.',
        },
      },

      eventsTexts: {
        wedding: (cityBet: string) =>
          `די ג׳יי לחתונה${cityBet} – מוזיקה שמתאימה בדיוק לזוג ולאורחים.`,
      
        henna: (cityBet: string) =>
          `די ג׳יי לחינה${cityBet} – שילוב מושלם של אותנטיות וביטים עדכניים.`,
      
        bar_bat: (cityBet: string) =>
          `די ג׳יי לבר/בת מצווה${cityBet} – להיטים לכל הדורות.`,
      
        event: (cityBet: string) =>
          `די ג׳יי לאירוע${cityBet} – חברה / פרטי, מותאם לכל סגנון.`,
      },

      groupTitlesSeo: {
        wedding: (keyword: string, cityBet: string, brand: string) => ({
          contact: `יצירת קשר עם ${brand}`,
          events: `קטגוריות אירועים נוספות${cityBet}`,
          services: `שירותים משלימים לחתונה${cityBet}`,
          links: `עמודים קשורים ל${keyword}${cityBet}`,
        }),
      
        henna: (keyword: string, cityBet: string, brand: string) => ({
          contact: `יצירת קשר עם ${brand}`,
          events: `עוד סוגי אירועים שאני מרים${cityBet}`,
          services: `שירותים משלימים לחינה${cityBet}`,
          links: `עמודים קשורים ל${keyword}${cityBet}`,
        }),
      
        bar_bat: (keyword: string, cityBet: string, brand: string) => ({
          contact: `יצירת קשר עם ${brand}`,
          events: `קטגוריות אירועים פופולריות${cityBet}`,
          services: `שירותים משלימים לבר/בת מצווה${cityBet}`,
          links: `עמודים קשורים ל${keyword}${cityBet}`,
        }),
      
        event: (keyword: string, cityBet: string, brand: string) => ({
          contact: `יצירת קשר עם ${brand}`,
          events: `קטגוריות אירועים שאני מכסה${cityBet}`,
          services: `שירותים משלימים לאירועים${cityBet}`,
          links: `עמודים קשורים ל${keyword}${cityBet}`,
        }),
      },

    prefills: {
      wedding:
        'היי אליאור,\nאשמח לשמוע פרטים לגבי די ג׳יי לחתונה.',
      henna:
        'שלום אליאור,\nאני מתעניין בדי ג׳יי לחינה.',
      barBat:
        'היי,\nמחפש די ג׳יי לבר/בת מצווה – אפשר פרטים?',
      generic:
        'שלום,\nאני מחפש די ג׳יי לאירוע חברה / פרטי.',
    },
  },

  // ─────────────────────────────────────────────────────────────
  // SECTION 5 — FAQ
  // ─────────────────────────────────────────────────────────────

  section5: {
    title: 'מידע נוסף ושאלות נפוצות',
    linksHeading: 'עמודים קשורים שכדאי לבדוק',
    headingsSeo: {
      wedding: (keyword: string, cityBet: string) => [
        `תכנון מוזיקלי לחתונה${cityBet} מהשיחה הראשונה ועד`,
        `השיר האחרון, לפי הסגנון שלכם והקהל שמגיע לחגוג אתכם.`,
        `קבלת פנים אלגנטית עם מוזיקה נכונה שמכניסה`,
        `את האורחים לאווירה טובה ומשאירה מקום לשיחות ולמפגש.`,
        `ליווי מלא לחופה עם בחירת שירים מדויקת`,
        `לכניסת החתן, הכלה ורגע שבירת הכוס.`,
        `מעבר מתוכנן מהחופה לריקודי הפתיחה כך`,
        `שהאירוע ממשיך באופן טבעי והאורחים מצטרפים לרחבה.`,
        `קטע סלואו מרגש שמבוסס על מי שאתם`,
        `כזוג ויוצר רגע אישי שלא שוכחים.`,
        `שילוב של שירים וסגנונות שמתאימים לכל`,
        `שלב בערב, כדי שהרחבה תישאר מלאה והאורחים ייהנו מכל רגע.`,
        `${keyword}${cityBet} שמלווה אתכם עד סוף הערב`,
        `עם מוזיקה שמחזיקה את האנרגיה גבוהה וחיוך אצל כולם.`,
      ],
    
      henna: (keyword: string, cityBet: string) => [
        `תכנון חינה${cityBet} לפי המסורת של המשפחה`,
        `והאווירה שאתם רוצים ליצור, עם מוזיקה שמתאימה לחינה שמחה וצבעונית.`,
        `כניסה ראשונה עם דרבוקות ותהלוכה שמרימה`,
        `את כולם ופותחת את הערב באנרגיה טובה.`,
        `ריקודים מזרחיים ושירים מוכרים מהעדות`,
        `השונות במשפחה, כדי שכל אחד ירגיש חלק מהחגיגה.`,
        `כניסה שנייה חגיגית עם שירים מסורתיים`,
        `ורגע שמרים את כל הרחבה, בלי החלפת תלבושות.`,
        `טקס החינה בליווי מוזיקה שמתאימה למריחת`,
        `החינה, לברכות ולמעגלים של המשפחה.`,
        `זמן לצילומים ומתנות עם מוזיקה`,
        `נעימה שמתאימה לרגעים האישיים.`,
        `${keyword}${cityBet} שמביא את השילוב הנכון בין`,
        `מסורת, שמחה ומוזיקה שאנשים אוהבים.`,
      ],
    
      bar_bat: (keyword: string, cityBet: string) => [
        `תכנון בר/בת מצווה${cityBet} עם מוזיקה שמדברת גם`,
        `לנוער וגם למבוגרים, כדי שכל אחד ירגיש חלק מהחגיגה.`,
        `קבלת פנים עם מוזיקה קלילה ונעימה שמכינה`,
        `את האורחים לערב ומאפשרת מפגשים וצילומים.`,
        `כניסת מצווה מתואמת מראש עם שיר שבוחרים יחד,`,
        `הכרזה ורגע כניסה שהחוגג או החוגגת מרגישים בו במרכז הבמה.`,
        `ליווי דרשה, סרטון או מצגת עם מוזיקה`,
        `שמוסיפה רגש ומדגישה את חשיבות הרגע.`,
        `סטים קצביים עם שירים עדכניים לנוער בשילוב מוזיקה`,
        `שמתאימה גם למבוגרים, כך שהרחבה נשארת מלאה מכל הגילים.`,
        `אפשרות לקטע ריקוד מיוחד או שי שהחוגג בוחר`,
        `ולרגע בו הוא עולה לעמדה ומרגיש חלק פעיל מהאירוע.`,
        `חלוקה של זוהרים ואביזרים לרחבה שיוצרים`,
        `אנרגיה צעירה ומעלים את רמת ההתלהבות של כולם.`,
        `${keyword}${cityBet} שמוביל את הערב כך`,
        `שהנוער נהנה מהמוזיקה שלהם והמבוגרים מרגישים חלק מהשמחה.`,
      ],
    
      event: (
        keyword: string,
        cityBet: string,
        hasCity: boolean
      ) => {
        if (!hasCity) {
          return [
            `הכול מתחיל בשיחה מקדימה כדי להבין אתכם,`,
            `את הקהל שלכם ואת סוג האירוע שאתם מתכננים.`,
            `לאחר מכן אני בונה תכנית מוזיקלית שמתאימה`,
            `לקבלת הפנים, לרגעים רשמיים ולשיאים של הערב.`,
            `ברגעים המיוחדים כמו טקסים משפחתיים או`,
            `רגעי הוקרה, המוזיקה מדגישה את הרגש ומקרבת בין האנשים.`,
            `בשלב הריקודים הקצב מותאם לקהל כדי`,
            `לשמור על אנרגיה טובה על הרחבה.`,
            `המעברים בין השירים נקיים ומתוכננים כך`,
            `שהאורחים מרגישים שהמוזיקה מתפתחת בצורה טבעית.`,
            `הסאונד מותאם לאולם ולכמות האורחים כדי`,
            `שהמוזיקה תשמע טוב בכל חלק באירוע.`,
            `${keyword} שיוצר ערב חם, מקצועי ובלתי־נשכח`,
            `שהאורחים זוכרים גם אחרי שהוא מסתיים.`,
          ];
        }
    
        return [
          `תכנון אירוע${cityBet} עם ${keyword} שמותאם לאופי`,
          `שלכם, לסוג הקהל ולמקום שבו חוגגים.`,
          `כבר בשלב קבלת הפנים המוזיקה מותאמת`,
          `למפגש בין האורחים ויוצרת אווירה נעימה להתחלה.`,
          `לרגעים רשמיים כמו ברכות, מצגת קצרה או`,
          `טקס משפחתי נבחרת מוזיקה שמדגישה את המשמעות של הרגע.`,
          `בהמשך הערב אני מעלה בהדרגה את הקצב`,
          `ומעביר את המיקוד לרחבת הריקודים בצורה טבעית.`,
          `במהלך הערב אני קורא את הקהל ומחליט מתי`,
          `לשלב סגנונות שונים כדי להשאיר את הרחבה פעילה.`,
          `הסאונד מותאם לגודל האולם ולקהל באירוע${cityBet} כדי`,
          `שכל מי שנמצא במקום ייהנה מהמוזיקה.`,
          `${keyword}${cityBet} שמלווה אתכם לכל אורך הערב`,
          `וגורם לאורחים לצאת מרוצים מהחוויה שעברו.`,
        ];
      },
    },
    eventTypeDescription: {
      wedding: {
        mobile: (city: string, cityBet: string) =>
          `המוזיקה בחתונה שלכם${cityBet} נבנית סביב הסיפור והאווירה שאתם רוצים ליצור – מקבלת פנים נעימה, דרך החופה והרגעים המרגשים, ועד מסיבה מלאה באנרגיה שמחברת בין כל האורחים.`,
    
        desktop: (city: string, cityBet: string) =>
          `כדי להפוך את החתונה שלכם${cityBet} לחוויה בלתי נשכחת, אני יוצר עבורכם פסקול אישי שמותאם לכל שלב באירוע – מקבלת פנים אלגנטית ונעימה, דרך החופה והרגעים המרגשים, ועד מסיבה מלאה באנרגיה שמחברת בין כל האורחים. בעזרת קריאת קהל מדויקת, מעברים מוזיקליים חלקים ושילוב נכון בין סגנונות מוזיקליים, נבנית חוויה מוזיקלית שמובילה את האירוע לחגיגה אמיתית.`,
      },
    
      event: {
        mobile: (_city: string, cityBet: string) =>
          `בכל אירוע ${cityBet} אני מתאים את הסטייל המוזיקלי לאופי הקהל. המעברים חלקים, הפלייליסט מגוון והאנרגיה בונה אווירה מחשמלת שגורמת לכולם לרקוד.`,
    
        desktop: (_city: string, cityBet: string) =>
          `בכל אירוע ${cityBet} אני מתאים את הסאונד ואת סגנון המוזיקה לאופי הקהל ולמהות האירוע. עם שילוב נכון של להיטים, קלאסיקות, קצב מדויק ומעברים מקצועיים, אני יוצר אווירה עם חיבור מדויק לקהל – הערב רץ בקצב גבוה ומשאיר את כולם בתוך החוויה עד השיר האחרון.`,
      },
    
      bar_bat: {
        mobile: (_city: string, cityBet: string) =>
          `בר/בת מצווה ${cityBet} זו חגיגה של פעם בחיים. אני משלב להיטים עדכניים לנוער עם קלאסיקות שכל המשפחה אוהבת, יוצר רגעים של שיא ואווירה שכולם זוכרים.`,
    
        desktop: (_city: string, cityBet: string) =>
          `בר/בת מצווה ${cityBet} היא חגיגה של פעם בחיים, ואני יוצר שילוב מדויק בין מוזיקה עדכנית שהנוער אוהב לבין שירי מסיבה ועל־זמניים שכל המשפחה מתחברת אליהם. עם קצב נכון, רגעי שיא מרגשים ורחבה שמתמלאת באנרגיה, אני דואג שהאירוע יהיה שמח, צעיר ומלא זיכרונות טובים.`,
      },
    
      henna: {
        mobile: (_city: string, cityBet: string) =>
          `חינה${cityBet} היא מסורת צבעונית ושמחה. אני משלב מוזיקה אותנטית וקצב מודרני, דרבוקות ומעגלים – כדי להפוך את החינה שלכם למסיבה מלאה באנרגיה.`,
    
        desktop: (_city: string, cityBet: string) =>
          `חינה${cityBet} היא מסיבה צבעונית ומלאת מסורת, ואני מקפיד לשלב בין מוזיקה אותנטית שמחברת לשורשים לבין קצב מודרני שמרים את הרחבה. דרבוקות, מעגלים, מקצבים מזרחיים וסט עכשווי שמתאים לכל הגילאים – הכל כדי ליצור חוויה שמחה, חמה ומשפחתית שתשאיר את כולם עם חיוך גדול.`,
      },
    },
  },
  // ─────────────────────────────────────────────────────────────
  // SECTION 5 — RECOMENDS
  // ─────────────────────────────────────────────────────────────

  section6: {
    defaults: {
      title: (brandTitle: string) =>
        `ביקורות והמלצות על ${brandTitle}`,
    
      subtitle: (
        brandShort: string,
        keyword: string,
        cityBet: string
      ) =>
        `מה לקוחות מספרים על ${brandShort}?\nהמלצות על ${keyword}${cityBet} – חוות דעת אמיתיות על אנרגיה ברחבה, קריאת קהל ושירות מקצועי.`,
    },
    reviewsCount: (count: number) =>
      `מבוסס על ${count} ביקורות`,
  
  },

  // ─────────────────────────────────────────────────────────────
  // FOOTER
  // ─────────────────────────────────────────────────────────────

  footer: {
    copyright: (year: number) =>
      `© ${year} די ג׳יי אליאור מור – כל הזכויות שמורות`,
    recommendedPages: 'עוד עמודים מומלצים',
    accessibilityStatement: 'הצהרת נגישות',
  },

  // ─────────────────────────────────────────────────────────────
  // MISC
  // ─────────────────────────────────────────────────────────────

  misc: {
    professional: 'מקצועי',
    recommended: 'מומלץ',
  },

  planning: {
    readMoreLabel: 'למדריך המלא',
    previousLabel: 'הקודם',
    nextLabel: 'הבא',
    backHomeLabel: 'חזרה',
    articleEyebrow: (service: string) => `${service} - מדריך תכנון`,
    contactTitle: 'רוצים לתכנן את המוזיקה נכון?',
    contactButtonLabel: 'דברו איתי',
    whatsappLabel: 'וואטסאפ',
    phoneLabel: 'שיחה טלפונית',
    parentLinkLabel: (serviceLabel: string) => `עמוד ${serviceLabel}`,
    whatsappText: (articleTitle: string) =>
      `שלום אליאור, קראתי באתר את המדריך "${articleTitle}" ואשמח להתייעץ על תכנון מוזיקלי לאירוע שלי.`,
    trustTitle: 'איך להפוך את זה לתכנון אמיתי באירוע',
    trustParagraphs: (articleTitle: string, serviceLabel: string, brandShort: string) => [
      `${articleTitle} הוא לא רק רעיון יפה לרשימה. באירוע אמיתי הוא צריך להתחבר לקהל, למקום, למשפחה, לשעה ביום ולרצף המוזיקלי של הערב. כשאני מתכנן ${serviceLabel}, אני מסתכל על כל התמונה ולא רק על שיר אחד או אטרקציה אחת.`,
      `הניסיון שלי כ${brandShort} עוזר להבין איפה כדאי לתת לרגש מקום, איפה צריך להרים קצב, ואיפה דווקא שקט או מעבר קצר עושים עבודה טובה יותר. תכנון נכון מונע עצירות מיותרות ומאפשר לאורחים להרגיש שהערב זורם טבעי.`,
      `לפני האירוע אני אוהב להבין מי הקהל, אילו סגנונות חשובים לכם, מה לא תרצו לשמוע, ואילו רגעים חייבים להיות מדויקים. ככה אפשר לבנות תכנית מוזיקלית אמינה, אישית ומקצועית יותר.`,
      `אם משלבים אטרקציות, חשוב שהן יעבדו עם המוזיקה ולא נגדה: זיקוקים קרים לכניסה, תותחי עשן, בלונים מתפוצצים לסלואו, אותיות חתן וכלה, לייזרים, מתנפחים מעוצבים, וידאו AI או אפטר פארטי ברחבה צריכים להיכנס בנקודת זמן נכונה, עם תיאום מול האולם ועם סאונד שמתאים לרגע.`,
    ],
    workTitle: 'מה אני בודק איתכם לפני שסוגרים תכנית',
    workBullets: [
      'סדר האירוע והמעברים בין קבלת פנים, טקס, אוכל ורחבה.',
      'שירים שחייבים להיות, שירים שלא מתאימים לכם וסגנונות מועדפים.',
      'התאמה לקהל: משפחה, חברים, צעירים, מבוגרים או קהל עסקי.',
      'תיאום מול האולם, ספקים, נגנים, אטרקציות וציוד סאונד.',
      'בדיקה שהאטרקציות לא מסתירות צילום, לא חוסמות רחבה ולא מתנגשות עם שיא מוזיקלי אחר.',
      'תכנון רגעי אפטר פארטי, ירידה של הדיג׳יי לרחבה, החלפת סגנון מוזיקלי והרמת קצב לקהל שנשאר עד מאוחר.',
    ],
    carouselLabel: (title: string) => `${title} - מדריכים`,
    guideTitle: 'מדריך אירועים',
    guideSubtitle: 'כל המדריכים לתכנון חתונה, חינה, בר/בת מצווה ואירוע פרטי או עסקי במקום אחד.',
    relatedTitle: 'עוד מדריכים שיכולים לעזור',
    faqTitle: 'שאלות נפוצות',
    authorTitle: 'נכתב מניסיון בשטח',
    authorText: 'המאמר נכתב על בסיס ניסיון של מעל 15 שנים באירועים, חתונות, חינות ובר/בת מצווה. המטרה היא לתת לכם מידע מעשי שאפשר להשתמש בו באמת בתכנון האירוע, ולא רק רשימת רעיונות כללית.',
    sections: {
      חתונה: {
        title: 'ארגון חתונה',
        subtitle: 'מדריכים מעשיים לתכנון חתונה מלאה: בחירת שירי חופה וסלואו, בניית לו״ז מוזיקלי, שילוב אטרקציות עדכניות, תיאום נגנים והחלטות קטנות שעושות הבדל גדול ברחבה.',
        keys: ['wedding_chuppah_song', 'wedding_timeline', 'wedding_attractions', 'wedding_musicians', 'wedding_slow_song', 'wedding_music'],
      },
      חינה: {
        title: 'ארגון חינה',
        subtitle: 'מדריכי חינה לפי מסורת, משפחה ואווירה: כניסות, לו״ז, נגנים, אטרקציות, מקצבים עדתיים ומעברים נכונים בין טקס מרגש לבין רחבה שמחה וצבעונית.',
        keys: ['henna_entrance', 'henna_timeline', 'henna_attractions', 'henna_musicians', 'henna_music', 'henna_moroccan', 'henna_kurdish', 'henna_tunisian', 'henna_yemenite', 'henna_indian', 'henna_iraqi', 'henna_persian'],
      },
      'בר-מצווה': {
        title: 'ארגון בר מצווה',
        subtitle: 'מדריכים לתכנון בר או בת מצווה עם כניסה חזקה, שיר מוקלט, לו״ז נכון, אטרקציות לנוער, מוזיקה שמתאימה לחברים ולמשפחה ורחבה שלא נתקעת באמצע האירוע.',
        keys: ['bar_bat_entrance', 'bar_bat_timeline', 'bar_bat_attractions', 'bar_bat_musicians', 'bar_bat_recording', 'bar_bat_music'],
      },
      אירוע: {
        title: 'ארגון אירוע',
        subtitle: 'כלים לתכנון אירוע פרטי או עסקי בצורה מקצועית: מוזיקה לפי קהל, כניסה, לו״ז, אטרקציות, נגנים, אפטר פארטי, תאורה ואפקטים שעובדים יחד ולא מרגישים כמו עומס.',
        keys: ['event_entrance', 'event_music', 'event_music_timeline', 'event_attractions', 'event_musicians'],
      },
    },
    articles: {
      wedding_chuppah_song: {
        title: 'בחירת שיר כניסה לחופה',
        sectionTitle: 'איך לבחור שיר כניסה לחופה',
        description: 'שיר הכניסה לחופה הוא הרגע שבו כל העיניים עליכם. כך בוחרים שיר שמרגיש אישי, מרגש ונכון לקצב של הטקס.',
        imageAlt: 'זוג בכניסה לחופה עם מוזיקה מרגשת',
        intro: 'שיר חופה טוב לא נבחר רק לפי מה שפופולרי עכשיו. הוא צריך להתאים לאופי שלכם, לקצב ההליכה, למיקום החופה ולתחושה שאתם רוצים להשאיר לאורחים ברגע הראשון.',
        bullets: ['בחרו שיר שמרגיש שלכם גם בלי להסביר אותו.', 'בדקו שהפתיחה של השיר עובדת טוב לכניסה ולא מתחילה לאט מדי.', 'התאימו את אורך השיר למרחק ההליכה ולסדר הכניסות.', 'תאמו מראש עם הדיג׳יי את נקודת ההתחלה, הווליום והמעבר לטקס.'],
        cta: 'רוצים לבנות כניסה לחופה עם תזמון מדויק ושיר שמרגיש באמת שלכם? נדבר ונבנה את הרגע הזה יחד.',
        trustParagraphs: [
          'בכניסה לחופה אין מקום לאלתורים של הרגע האחרון. לפעמים השיר מדהים, אבל הפתיחה שלו ארוכה מדי, הווליום לא נכון או נקודת הכניסה לא מתאימה למרחק בין הדלת לחופה. אלה הפרטים הקטנים שעושים הבדל גדול ברגע שכולם מסתכלים.',
          'אני בודק עם הזוג מי נכנס לפני מי, כמה זמן לוקחת ההליכה, האם יש כניסה נפרדת לחתן ולכלה, ואיפה נכון להתחיל את השיר כדי שהשיא יגיע בדיוק כשהזוג עומד תחת החופה.',
          'אם יש זיקוקים קרים, עשן, נגנים או כניסה עם משפחות, חשוב לתאם את הכל מראש מול האולם והצלמים. המטרה היא שהרגע ירגיש מרגש וטבעי, לא טכני ולא לחוץ.',
        ],
        workBullets: [
          'בחירת שיר או גרסה שמתאימה לקצב ההליכה ולסגנון הזוג.',
          'סימון נקודת התחלה, נקודת שיא ונקודת יציאה מהשיר.',
          'תיאום סדר הכניסות של ההורים, החתן, הכלה והמלווים.',
          'בדיקת ווליום נכון לחופה פתוחה, אולם סגור או גן אירועים.',
          'תיאום מול נגנים, זיקוקים קרים, עשן וצלמים אם משלבים אפקטים.',
        ],
      },
      wedding_timeline: {
        title: 'תכנון לו״ז חתונה',
        sectionTitle: 'איך בונים לו״ז חתונה נכון',
        description: 'לו״ז חתונה מסודר מחבר בין קבלת פנים, חופה, סלואו ורחבה בלי נפילות אנרגיה.',
        imageAlt: 'תכנון לוח זמנים מוזיקלי לחתונה',
        intro: 'הלו״ז הוא השלד של החתונה. כשהוא ברור, הדיג׳יי, האולם, הצלם והזוג יודעים מתי כל רגע קורה ואיך עוברים אליו בלי לחץ.',
        bullets: ['קבעו מראש זמני קבלת פנים, חופה, אוכל וסלואו.', 'השאירו מרווחים קטנים לעיכובים טבעיים.', 'תאמו נקודות שיא כמו שבירת כוס וכניסת זוג.', 'חברו כל מעבר מוזיקלי לאנרגיה הרצויה ברחבה.'],
        cta: 'לו״ז מוזיקלי טוב מוריד לחץ ומחזיק את הערב בקצב נכון מהחופה ועד הסוף.',
        trustParagraphs: [
          'בחתונה, הלו״ז משפיע ישירות על הרחבה. חופה שמתחילה מאוחר מדי, אוכל שנמשך יותר מדי או סלואו שנכנס אחרי שהקהל כבר התפזר יכולים לשבור אנרגיה גם באירוע עם מוזיקה מצוינת.',
          'אני מסתכל על הלו״ז כמו רצף של אנרגיות: קבלת פנים נעימה, חופה מרגשת, שבירת כוס שמרימה את כולם, אוכל בלי איבוד קשב, פתיחת רחבה חזקה ואז בנייה הדרגתית עד אפטר פארטי.',
          'כשהספקים יודעים מראש מתי כל רגע קורה, אין צעקות באוזן ואין ריצות בין עמדות. הכל זורם נקי יותר, וגם הזוג מרגיש שיש מישהו שמחזיק את הקצב של הערב.',
        ],
        workBullets: [
          'זמני קבלת פנים, חופה, מנה ראשונה, עיקרית, סלואו ופתיחת רחבה.',
          'נקודות שבהן צריך מוזיקה מדויקת: שבירת כוס, כניסה לאולם, סלואו ואפטר פארטי.',
          'מרווחים לעיכובים טבעיים בלי להפוך את הערב לאיטי.',
          'תיאום מול מנהל האירוע, צלמים, נגנים ואטרקציות.',
          'החלטה איפה שומרים על רגש ואיפה מעלים קצב בלי להסס.',
        ],
      },
      wedding_attractions: {
        title: 'אטרקציות לחתונה',
        sectionTitle: 'איך לבחור אטרקציות לחתונה',
        description: 'אטרקציות לחתונה צריכות להוסיף חוויה, תמונות ואנרגיה בלי לגנוב את הפוקוס מהמוזיקה ומהרחבה. הבחירה הנכונה היא שילוב מדויק בין אפקט מרגש, תזמון נכון ותפעול שלא מפריע לאורחים לרקוד.',
        imageAlt: 'אטרקציות לחתונה ברחבת הריקודים',
        intro: 'בחתונות של היום אפשר לשלב זיקוקים קרים לכניסה, בלונים מתפוצצים לסלואו, תותחי עשן, אותיות מוארות של חתן וכלה כמו E&A, לייזרים, מתנפחים מעוצבים, וידאו AI, עמדות צילום ואפטר פארטי לפי סגנון מוזיקלי. הסוד הוא לא לקחת הכל, אלא לבחור מה באמת מתאים לאופי שלכם ולמקום.',
        bullets: ['בחרו אטרקציות שמתאימות לקהל ולא רק לטרנד: סלואו רומנטי יכול לעבוד עם בלונים או עשן, וחתונה צעירה יכולה לקבל אפטר פארטי עם ירידה של הדיג׳יי לרחבה.', 'ודאו שהאטרקציות לא חוסמות את הרחבה, לא מסתירות את הצלם ולא דורשות הפסקה ארוכה מדי מהמוזיקה.', 'תאמו עם הדיג׳יי והאולם את נקודת ההפעלה של זיקוקים קרים, לייזרים, עשן או וידאו AI כדי שהאפקט ייפול בדיוק על השיא המוזיקלי.', 'עדיף לבחור שניים או שלושה רגעי וואו מדויקים מאשר לפזר הרבה גימיקים שגורמים לאירוע להרגיש עמוס.'],
        cta: 'אפשר לשלב אטרקציות בצורה שמחזקת את החופה, הסלואו והרחבה בלי להפריע לזרימה של החתונה.',
        trustParagraphs: [
          'אטרקציה טובה בחתונה היא לא משהו שמכניסים כי “כולם עושים”. היא צריכה לשרת רגע ברור: כניסה, סלואו, פתיחת רחבה, אפטר פארטי או תמונה משפחתית חזקה.',
          'ראיתי אירועים שבהם יותר מדי אפקטים עצרו את הרחבה במקום להרים אותה. לכן אני מעדיף לבחור מעט רגעים מדויקים: זיקוקים קרים בכניסה, בלונים בסלואו, לייזרים בשיא הרחבה או וידאו AI שמופיע בזמן נכון.',
          'הבדיקה החשובה היא תפעולית: האם יש אישור אולם, מי מפעיל, איפה עומדים הצלמים, האם העשן מפריע לחופה, והאם האפקט יושב על הדרופ או נכנס באיחור.',
        ],
        workBullets: [
          'בחירת אטרקציות לפי אופי הזוג ולא רק לפי טרנד.',
          'תזמון זיקוקים, עשן, בלונים, לייזרים או אותיות מוארות מול המוזיקה.',
          'בדיקת מגבלות אולם: חשמל, גובה, בטיחות, צילום ומיקום ברחבה.',
          'הפרדה בין רגעי רגש לבין רגעי מסיבה כדי לא לערבב יותר מדי.',
          'בניית אפטר פארטי לפי סגנון הקהל שנשאר לרקוד עד מאוחר.',
        ],
      },
      wedding_musicians: {
        title: 'נגנים לחתונה',
        sectionTitle: 'מתי כדאי לשלב נגנים בחתונה',
        description: 'נגנים לחתונה יכולים להוסיף רגש לקבלת פנים, לחופה או לפתיחת הרחבה כשהשילוב מתוכנן נכון.',
        imageAlt: 'נגנים לחתונה בקבלת פנים',
        intro: 'סקסופון, כנרית, דרבוקות או הרכב לקבלת פנים יוצרים שכבה חיה מעל המוזיקה, אבל חייבים תיאום מוזיקלי עם הדיג׳יי.',
        bullets: ['בחרו אם הנגנים מתאימים לקבלת פנים, חופה או רחבה.', 'תאמו סולמות, שירים ונקודות כניסה מראש.', 'ודאו שיש חיבור סאונד מתאים באולם.', 'שמרו על שילוב קצר ומדויק כדי לא לעייף את הקהל.'],
        cta: 'שילוב נכון של נגנים יכול להפוך רגעים חשובים לחיים ומרגשים יותר.',
        trustParagraphs: [
          'נגנים בחתונה יכולים להיות מדהימים, אבל רק כשהם יודעים איפה הם נכנסים ואיפה הם מפנים מקום לדיג׳יי. סקסופון בקבלת פנים, כנרית בחופה או דרבוקות בפתיחת רחבה הם שלושה תפקידים שונים לגמרי.',
          'הטעות הנפוצה היא להביא נגן טוב בלי תיאום מוזיקלי. צריך לדעת אילו שירים מנגנים, באיזה סולם, איך הוא מתחבר למיקס, והאם הוא צריך מיקרופון, DI או חיבור אחר לסאונד.',
          'כשהשילוב נכון, הנגן לא “גונב הצגה” אלא מוסיף שכבה חיה לרגע הנכון. זה מורגש במיוחד בקבלת פנים אלגנטית או בפתיחת רחבה שצריכה עוד דחיפה.',
        ],
        workBullets: [
          'החלטה אם הנגנים מתאימים לקבלת פנים, חופה, סלואו או רחבה.',
          'תיאום רשימת שירים, סולמות, כניסות וסיומות.',
          'בדיקת צרכי סאונד מול האולם לפני האירוע.',
          'קביעת משך הופעה כדי שהנגן יחזק את האירוע ולא יעייף את הקהל.',
          'תיאום מעבר נקי בין נגינה חיה לבין סט הדיג׳יי.',
        ],
      },
      wedding_slow_song: {
        title: 'בחירת שיר לריקוד סלואו',
        sectionTitle: 'איך לבחור שיר סלואו לחתונה',
        description: 'שיר הסלואו צריך להחזיק רגע אינטימי מול כל האורחים. הנה דרך פשוטה לבחור שיר מרגש בלי להרגיש מאולצים.',
        imageAlt: 'רחבת חתונה בזמן ריקוד סלואו',
        intro: 'הסלואו הוא רגע קצר, אבל כשהוא מתוכנן נכון הוא נשאר בזיכרון. השיר צריך להתאים לכם, לאורך הריקוד, לאופי המשפחה ולרמת הדרמה שאתם רוצים ליצור.',
        bullets: ['בחרו שיר שאתם באמת אוהבים, גם אם הוא פחות מוכר.', 'אל תבחרו שיר ארוך מדי אם אין כוריאוגרפיה מלאה.', 'חשבו מראש אם תרצו להזמין את המשפחה והחברים להצטרף באמצע.', 'בקשו מהדיג׳יי להכין גרסה מקוצרת או נקודת יציאה נקייה במידת הצורך.'],
        cta: 'אפשר להפוך את הסלואו לרגע טבעי, מרגש ולא מביך. נבחר יחד את השיר והמבנה שמתאימים לכם.',
        trustParagraphs: [
          'סלואו טוב לא חייב להיות דרמטי מדי. לפעמים דווקא שיר פשוט, עם עריכה נכונה וכניסה נקייה של המשפחה באמצע, מרגיש הרבה יותר אמיתי מריקוד ארוך שהזוג רק מחכה שייגמר.',
          'אני בודק עם הזוג אם הם רוצים ריקוד מלא, חצי דקה אינטימית ואז הצטרפות משפחה, או סלואו קצר שמוביל ישר לפתיחת רחבה. לכל בחירה יש עריכה מוזיקלית אחרת.',
          'אם משלבים בלונים מתפוצצים, עשן כבד, זיקוקים קרים או אותיות, צריך שהאפקט יגיע ברגע הנכון ולא יסתיר את הזוג או את הצילום.',
        ],
        workBullets: [
          'בחירת שיר שמתאים לזוג ולא רק לרשימות מומלצות.',
          'קיצור השיר או בניית נקודת יציאה מקצועית.',
          'החלטה מתי המשפחה והחברים מצטרפים לריקוד.',
          'תיאום אפקטים כמו בלונים, עשן או זיקוקים מול הצלם והאולם.',
          'מעבר נקי מהסלואו לפתיחת רחבה בלי נפילת אנרגיה.',
        ],
      },
      wedding_music: {
        title: 'בחירת מוזיקה לחתונה',
        sectionTitle: 'איך לבחור מוזיקה לחתונה',
        description: 'מוזיקה לחתונה צריכה לחבר בין המשפחות, החברים והזוג. הבחירה הנכונה מתחילה בהבנת הקהל וממשיכה בשילוב מדויק של סגנונות לאורך הערב.',
        imageAlt: 'דיג׳יי מתכנן מוזיקה לחתונה',
        intro: 'חתונה טובה לא נבנית מפלייליסט אחד. יש קבלת פנים, חופה, שבירת כוס, סלואו, אוכל, רחבה ואפטר פארטי. בכל שלב צריך להבין מי נמצא מולכם: חברים צעירים, משפחה מבוגרת, קהל דתי, קהל חילוני, אורחים שאוהבים מזרחית, נוסטלגיות, לטינית, היפ הופ, טראנס, טכנו או להקות ישראליות.',
        bullets: ['התחילו מהקהל: כמה צעירים מגיעים, כמה מבוגרים, האם יש קהל דתי ומה הסגנונות שמחברים את שתי המשפחות.', 'רשמו זמרים ולהקות שאתם והמשפחה באמת אוהבים: מזרחית, ישראלי, חסידי ודתי, לטיני, פופ, היפ הופ, נוסטלגיות, טראנס וטכנו.', 'הפרידו בין שירים שחייבים להיות לבין שירים שלא מתאימים לכם, כדי שהדיג׳יי יוכל לקרוא את הרחבה בלי לפגוע בטעם שלכם.', 'בנו זרימה: קבלת פנים נעימה, חופה מרגשת, פתיחת רחבה שמחברת את כולם, ואז קצב שעולה לפי הקהל שנשאר לרקוד.'],
        cta: 'בחירת מוזיקה לחתונה היא שילוב בין טעם אישי לקריאת קהל מקצועית. כשמדייקים את זה מראש, הרחבה מרגישה טבעית ולא מאולצת.',
        trustParagraphs: [
          'בחתונה יש שני קהלים לפחות: המשפחה והחברים. לפעמים יש גם צד דתי, צד חילוני, חברים מהצבא, קהל רוסי, קהל מרוקאי, אורחים שאוהבים טראנס וחברים שרוצים היפ הופ. התפקיד של הדיג׳יי הוא לא לרצות את כולם בכל שיר, אלא לבנות רצף שבו כולם מקבלים מקום.',
          'אני לא מבקש מהזוג פלייליסט של 200 שירים. הרבה יותר חשוב להבין מה הסגנון שלכם, מי האורחים, מה אסור להשמיע, ואילו רגעים חייבים להיות אישיים. משם אפשר לקרוא את הרחבה בזמן אמת בלי לאבד את הזהות שלכם.',
          'מוזיקה לחתונה עובדת כשהיא נבנית בשכבות: קבלת פנים נעימה, חופה מרגשת, פתיחת רחבה שמחברת משפחות, סטים צעירים יותר בהמשך ואפטר פארטי למי שנשאר עד הסוף.',
        ],
        workBullets: [
          'מיפוי הקהל לפי גיל, משפחות, חברים, קהל דתי וסגנונות אהובים.',
          'רשימת חובה קצרה לצד רשימת שירים שלא תרצו לשמוע.',
          'בחירת סגנונות לקבלת פנים, חופה, רחבה ואפטר פארטי.',
          'שילוב מזרחית, ישראלי, לטיני, היפ הופ, נוסטלגיות, טראנס וטכנו לפי התגובה ברחבה.',
          'שמירה על זהות הזוג לצד קריאת קהל בזמן אמת.',
        ],
      },
      henna_entrance: {
        title: 'כניסה לחינה',
        sectionTitle: 'איך מתכננים כניסה לחינה',
        description: 'כניסה לחינה צריכה לפתוח את הערב בצבע, משפחתיות וקצב שמתאים למסורת שלכם.',
        imageAlt: 'כניסה חגיגית לחינה',
        intro: 'הכניסה היא הרגע שבו החינה מקבלת צורה. כדאי לתכנן מי נכנס, באיזה שיר, מה הקצב ואיך ממשיכים לטקס בלי עצירה.',
        bullets: ['בחרו שיר כניסה שמתאים לעדה ולאופי המשפחה.', 'תאמו את סדר הכניסה של הזוג והמשפחות.', 'שלבו תופים או נגנים רק אם הם משרתים את הרגע.', 'הכינו מעבר ברור מהכניסה לטקס החינה.'],
        cta: 'כניסה לחינה טובה מרימה את כל המשפחה כבר מהדקה הראשונה.',
        trustParagraphs: [
          'כניסה לחינה היא לא רק “שיר שמח”. זה רגע שבו המשפחות נכנסות לאווירה, העדה מקבלת מקום, והזוג הופך למרכז הערב. אם הכניסה ארוכה מדי או לא מתוזמנת, האנרגיה נופלת עוד לפני הטקס.',
          'אני בודק מראש מי נכנס עם הזוג, האם יש תלבושות, מגשים, דרבוקות או זיקוקים קרים, ומה השיר הנכון לפתיחה לפי המסורת של המשפחה.',
          'המעבר אחרי הכניסה חשוב לא פחות מהכניסה עצמה. צריך לדעת אם ממשיכים לברכות, לטקס מריחת החינה, להחלפת תלבושת או לרחבה קצרה.',
        ],
        workBullets: [
          'בחירת שיר כניסה לפי עדה, משפחה וקצב רצוי.',
          'סידור כניסת הזוג, ההורים, המלווים והמגשים.',
          'תיאום דרבוקות, נגנים, זיקוקים קרים או עשן אם משלבים.',
          'הכנת מעבר ברור מהכניסה לטקס כדי לא ליצור עצירה.',
          'בדיקת ווליום מתאים לכניסה עם קהל מבוגר ומשפחה קרובה.',
        ],
      },
      henna_timeline: {
        title: 'תכנון לו״ז חינה',
        sectionTitle: 'איך בונים לו״ז לחינה',
        description: 'לו״ז חינה נכון מחבר כניסה, טקס, תלבושות ורחבה בלי שהערב ירגיש מקוטע.',
        imageAlt: 'תכנון לוח זמנים לחינה',
        intro: 'בחינה יש הרבה רגעים משפחתיים, ולכן חשוב לבנות סדר ברור שמאפשר לטקס לקבל מקום ועדיין לשמור על קצב.',
        bullets: ['סדרו מראש כניסה, החלפת תלבושות, טקס וריקודים.', 'השאירו זמן לברכות ולרגעים משפחתיים.', 'תאמו עם הדיג׳יי איפה מעלים קצב.', 'אל תעמיסו יותר מדי עצירות בין חלקי הערב.'],
        cta: 'לו״ז מדויק לחינה שומר על מסורת, שמחה ואנרגיה.',
        trustParagraphs: [
          'בחינה יש נטייה טבעית לעצירות: תלבושות, ברכות, מגשים, טקס, תמונות ומשפחה שרוצה לקחת חלק. בלי לו״ז ברור, הערב יכול להרגיש כמו רצף של הפסקות במקום חגיגה אחת זורמת.',
          'אני בונה את הלו״ז כך שהטקס יקבל כבוד, אבל הרחבה לא תיפתח מאוחר מדי. צריך לדעת איפה נותנים למבוגרים רגע, איפה מכניסים מעגלים, ואיפה עוברים למסיבה.',
          'הדגש הוא לא לקצר את המסורת, אלא לסדר אותה נכון. כשכל רגע מקבל מקום, החינה מרגישה משפחתית ומכובדת ועדיין שמחה.',
        ],
        workBullets: [
          'סידור כניסה, תלבושות, טקס מריחת חינה, ברכות וריקודים.',
          'החלטה מתי משאירים מוזיקה עדתית ומתי עוברים לקצב כללי יותר.',
          'תיאום זמני צילום ותלבושות כדי שלא לעצור את הרחבה.',
          'שילוב נגנים או דרבוקות בנקודות שבהן הם באמת מוסיפים.',
          'שמירה על מעבר קצר וברור מהטקס למסיבה.',
        ],
      },
      henna_attractions: {
        title: 'אטרקציות לחינה',
        sectionTitle: 'איך לבחור אטרקציות לחינה',
        description: 'אטרקציות לחינה צריכות לחזק את הצבע, המסורת והמשפחתיות בלי להפוך את הערב לעמוס מדי. תכנון נכון מחבר בין תלבושות, כניסות, תופים, צילום, תאורה ורחבה שמחה.',
        imageAlt: 'אטרקציות צבעוניות לחינה',
        intro: 'בחינה אפשר לשלב תלבושות מסורתיות, מגשים מעוצבים, דרבוקות, כניסה עם זיקוקים קרים, תותחי עשן, אותיות מוארות, עמדת צילום, מתנפחים מעוצבים או וידאו AI קצר שמספר את הסיפור של הזוג. כל אטרקציה צריכה לשרת את הטקס ולא למשוך אותו יותר מדי.',
        bullets: ['בחרו אטרקציות שמתאימות למסורת המשפחתית ולעדה, למשל חינה מרוקאית צבעונית, חינה תימנית עם שירה או חינה הודית עם כניסה עשירה ותלבושות.', 'שמרו על מספיק מקום לריקודים, למעגלים ולמשפחה המבוגרת כדי שהערב לא יהפוך לתור בין עמדות.', 'תאמו מתי כל אטרקציה נכנסת לטקס: כניסה, ברכות, מריחת חינה, החלפת תלבושות או פתיחת רחבה.', 'בדקו מראש מי אחראי על ההפעלה בזמן אמת, במיוחד כשיש עשן, זיקוקים קרים, נגנים או וידאו שצריך לעלות בדיוק בזמן.'],
        cta: 'אטרקציות נכונות לחינה מוסיפות צבע, מסורת ואנרגיה בלי לעצור את השמחה.',
        trustParagraphs: [
          'בחינה האטרקציות צריכות להרגיש חלק מהמסורת ולא כמו תוספת מקרית. מגשים, תלבושות, דרבוקות, תאורה, אותיות, וידאו או זיקוקים צריכים להתחבר לסיפור של המשפחה.',
          'הטעות הנפוצה היא להעמיס יותר מדי דברים: כל ספק רוצה רגע, אבל הקהל רוצה להרגיש שמחה ורצף. לכן עדיף לבחור כמה רגעים מדויקים ולתת להם תזמון טוב.',
          'אני בודק איפה האטרקציה עומדת, מי מפעיל אותה, האם היא מפריעה למעגלים, והאם היא נכנסת על שיר נכון או יוצרת הפסקה טכנית.',
        ],
        workBullets: [
          'בחירת אטרקציות לפי עדה, משפחה ואופי האולם.',
          'תזמון תלבושות, מגשים, זיקוקים, עשן, וידאו AI ואותיות מוארות.',
          'שמירה על מקום למעגלים, לצילום ולמשפחה המבוגרת.',
          'בדיקת בטיחות ואישורי אולם לאפקטים מיוחדים.',
          'חיבור האטרקציות למוזיקה כדי שהן יחזקו את הטקס ולא יעצרו אותו.',
        ],
      },
      henna_musicians: {
        title: 'נגנים לחינה',
        sectionTitle: 'שילוב נגנים בחינה',
        description: 'נגנים לחינה מוסיפים קצב אותנטי לכניסה, לטקס ולמעגלים המשפחתיים.',
        imageAlt: 'נגנים ותופים באירוע חינה',
        intro: 'דרבוקות, זמר אורח או כלי נגינה מסורתיים יכולים להרים את החינה, אבל הם צריכים לעבוד יחד עם הדיג׳יי והלו״ז.',
        bullets: ['בחרו נגנים שמכירים את הסגנון העדתי שלכם.', 'תאמו מראש שירים, מקצבים ורגעי כניסה.', 'ודאו שהסאונד מתאים גם לנגנים וגם לדיג׳יי.', 'שמרו על איזון בין הופעה לבין רחבה פתוחה.'],
        cta: 'נגנים נכונים יכולים לתת לחינה אופי חי, משפחתי ומרגש.',
        trustParagraphs: [
          'נגנים בחינה יכולים לתת תחושה אותנטית מאוד, במיוחד בדרבוקות, שירה עדתית או כלי נגינה שמתחבר למנהגי המשפחה. אבל הם צריכים להיות חלק מהערב, לא מופע נפרד שמנתק את הרחבה.',
          'החיבור בין הדיג׳יי לנגנים חשוב במיוחד בחינה, כי יש מעברים בין טקס, מעגלים, ברכות וריקודים. אם אין תיאום, מקבלים חפיפה מוזיקלית או עצירה מוזרה.',
          'כשהנגנים יודעים את הרגע שלהם, הם יכולים לפתוח כניסה חזקה, להרים מעגלים ולתת למשפחה המבוגרת להרגיש בבית.',
        ],
        workBullets: [
          'בחירת נגנים שמכירים את הסגנון העדתי של המשפחה.',
          'תיאום כניסות, מקצבים, שירים וסיומות מול הדיג׳יי.',
          'בדיקת מיקרופונים, חיבורים והגברה מול המקום.',
          'החלטה אם הנגנים מלווים טקס, כניסה או רחבה.',
          'שמירה על איזון בין אותנטיות לבין מסיבה לכל האורחים.',
        ],
      },
      henna_music: {
        title: 'בחירת מוזיקה לחינה',
        sectionTitle: 'איך לבחור מוזיקה לחינה',
        description: 'מוזיקה לחינה צריכה לכבד את המסורת של המשפחה, אבל גם לפתוח רחבה שמחה. הבחירה הנכונה משלבת שורשים, קצב עדכני וקהל מכל הגילים.',
        imageAlt: 'בחירת מוזיקה לחינה עם קצב ומסורת',
        intro: 'בחינה יש רגעים שלא כדאי לפספס: כניסה, החלפת תלבושות, ברכות, טקס החינה, מעגלים וריקודים. כדי לבחור מוזיקה נכון צריך להבין מאיזו עדה מגיעה המשפחה, מי הקהל המבוגר, מי הצעירים, אילו שירים שרים בבית ואיזה סגנון יפתח את הרחבה אחרי הטקס.',
        bullets: ['אספו שירים עדתיים ומשפחתיים חשובים: מרוקאית, תימנית, פרסית, עיראקית, כורדית, תוניסאית, הודית או שילוב בין מסורות.', 'שלבו בין מוזיקה אותנטית לבין מזרחית, ישראלי, לטינית, היפ הופ, נוסטלגיות וקצב עדכני כדי שגם הצעירים וגם המבוגרים ירגישו חלק.', 'בדקו אם יש קהל דתי או מסורתי שצריך שירים מתאימים יותר לפתיחה, לברכות או למעגלים.', 'תכננו עם הדיג׳יי את המעבר מהטקס לרחבה, כי שם החינה הופכת מאירוע משפחתי למסיבה שמחה.'],
        cta: 'מוזיקה לחינה טובה מרגישה כמו המשפחה שלכם: מכבדת, צבעונית, שמחה ומדויקת לקהל שנמצא באולם.',
        trustParagraphs: [
          'בחינה טובה נשענת על זיכרונות מהבית: שירים של ההורים, מקצבים של העדה, רגעים שהמשפחה מחכה להם. אם מתייחסים אליה כמו חתונה קטנה עם פלייליסט רגיל, מפספסים את הלב של האירוע.',
          'אני מבקש להבין מה חשוב למשפחה: מרוקאית, תימנית, עיראקית, פרסית, כורדית, תוניסאית, הודית או שילוב בין עדות. משם בונים רצף שמכבד את המבוגרים אבל עדיין עובד לצעירים.',
          'המעבר הקריטי הוא אחרי הטקס. שם צריך להפוך את האנרגיה ממשפחתית למסיבתית בלי למחוק את האופי של החינה.',
        ],
        workBullets: [
          'איסוף שירים עדתיים ומשפחתיים שחייבים להיכנס.',
          'הבנת הקהל המבוגר, הצעירים והקהל הדתי או המסורתי.',
          'שילוב מוזיקה עדתית עם מזרחית, ישראלי, לטינית, היפ הופ ונוסטלגיות.',
          'תכנון מעבר מהטקס לרחבה בצורה טבעית ולא חדה מדי.',
          'שמירה על כבוד למסורת לצד רחבה שמחה ועדכנית.',
        ],
      },
      henna_moroccan: {
        title: 'חינה מרוקאית',
        sectionTitle: 'איך מתכננים חינה מרוקאית שמחה',
        description: 'חינה מרוקאית משלבת תלבושות, טקס, מקצבים והרבה משפחה. כך בונים ערב צבעוני עם מוזיקה שמרימה את כולם.',
        imageAlt: 'רחבה שמחה באירוע חינה מרוקאית',
        intro: 'בחינה מרוקאית המוזיקה צריכה לתת מקום למסורת ולטקס, אבל גם לפתוח רחבה שמחה ומעודכנת. האיזון בין רגעים משפחתיים לקצב גבוה הוא כל הסיפור.',
        bullets: ['תכננו מראש את סדר הכניסות והחלפת התלבושות.', 'שלבו מקצבים מרוקאיים לצד להיטים מזרחיים ועכשוויים.', 'השאירו מקום לשירים משפחתיים שמכירים מהבית.', 'תאמו עם הדיג׳יי את רגעי השיא של הטקס כדי למנוע עצירות מיותרות.'],
        cta: 'לחינה מרוקאית צריך פסקול שמכיר את המסורת וגם יודע להרים רחבה. אשמח לבנות איתכם את הערב.',
        trustParagraphs: [
          'בחינה מרוקאית היא בדרך כלל צבעונית, משפחתית ומלאה ברגעים: תלבושות, מגשים, כניסה, טקס, ברכות ומעגלים. המוזיקה צריכה להחזיק את כל זה בלי להפוך את הערב למקוטע.',
          'חשוב לשלב שירים שמוכרים למשפחה ולא להסתפק בסט מזרחית רגיל. השירים המרוקאיים נותנים לאירוע את הזהות שלו, והלהיטים העכשוויים פותחים את הרחבה לצעירים.',
          'כשהכניסה, התלבושות והטקס מתוזמנים נכון, החינה מרגישה עשירה אבל לא עמוסה.',
        ],
        workBullets: [
          'סידור כניסות, תלבושות, מגשים וטקס לפי המשפחה.',
          'שילוב מקצבים מרוקאיים עם מזרחית ולהיטים עדכניים.',
          'שמירת מקום לשירים משפחתיים שמכירים מהבית.',
          'תזמון מעברים בין טקס, ברכות ורחבה.',
          'תיאום אטרקציות צבעוניות בלי להכביד על האירוע.',
        ],
      },
      henna_kurdish: {
        title: 'חינה כורדית',
        sectionTitle: 'תכנון מוזיקה לחינה כורדית',
        description: 'חינה כורדית מביאה איתה אופי משפחתי, מקצבים מסורתיים ואווירה חמה. כך משלבים בין שורשים למסיבה.',
        imageAlt: 'חגיגה משפחתית ברחבת חינה כורדית',
        intro: 'בחינה כורדית חשוב לתת למשפחה להרגיש בבית. לצד המוזיקה העדתית, כדאי לבנות מעברים חכמים לשירים שכל האורחים יכולים לרקוד איתם.',
        bullets: ['אספו מראש שירים מסורתיים שחשובים למשפחה.', 'בנו רצף כניסה וטקס ברור, בלי עומס מוזיקלי.', 'שלבו מעגלים, מזרחית ולהיטים מוכרים לפי הקהל.', 'השאירו מקום לבקשות מהמשפחה, אבל הגדירו גבולות כדי לשמור על זרימה.'],
        cta: 'אם חשוב לכם לשמור על המסורת וגם ליצור מסיבה חיה, נבנה תכנון מוזיקלי מדויק לחינה.',
        trustParagraphs: [
          'בחינה כורדית נשענת הרבה על משפחתיות, מעגלים ושירים שהמבוגרים מזהים מיד. כשנותנים לזה מקום נכון, גם הצעירים נכנסים לאווירה כי הם מרגישים שהאירוע אמיתי ולא מועתק.',
          'אני בודק עם המשפחה אילו שירים חייבים להיות ואילו שירים עדיף להשאיר מחוץ לרשימה. בחינות כאלה חשוב מאוד לאזן בין בקשות משפחתיות לבין רצף מוזיקלי שמחזיק את הרחבה.',
          'המטרה היא לא להפוך את כל הערב למסורתי בלבד, אלא לבנות מעבר נעים ממקצבים כורדיים למזרחית, ישראלי ולהיטים מוכרים.',
        ],
        workBullets: [
          'איסוף שירים כורדיים ומשפחתיים לפני האירוע.',
          'תכנון מעגלים וכניסות בלי למשוך את הטקס יותר מדי.',
          'שילוב מזרחית ולהיטים מוכרים אחרי הרגעים המסורתיים.',
          'ניהול בקשות משפחתיות בזמן אמת בלי לשבור את הרחבה.',
          'שמירה על אופי משפחתי חם לצד מסיבה פתוחה.',
        ],
      },
      henna_tunisian: {
        title: 'חינה תוניסאית',
        sectionTitle: 'איך בונים חינה תוניסאית עם קצב נכון',
        description: 'חינה תוניסאית היא שילוב של טקס, משפחתיות ושמחה גדולה. הנה הדגשים שיעזרו למוזיקה להחזיק את הערב.',
        imageAlt: 'מוזיקה ורחבה באירוע חינה תוניסאית',
        intro: 'היופי בחינה תוניסאית הוא בשילוב בין רגעים מסורתיים לבין חגיגה פתוחה. כשהדיג׳יי מכיר את הסדר ואת הקהל, הערב מרגיש טבעי ולא מקוטע.',
        bullets: ['הכינו רשימת שירים משפחתיים שחייבים להיכנס.', 'סדרו מראש את רגעי הטקס, הברכות והכניסות.', 'שלבו בין מקצבים תוניסאיים לבין להיטים שמתאימים לצעירים.', 'שמרו על מעברים קצרים כדי שהאנרגיה לא תרד.'],
        cta: 'לחינה תוניסאית טובה צריך להרגיש את המשפחה ואת הרחבה יחד. נדייק את זה מראש.',
        trustParagraphs: [
          'בחינה תוניסאית צריכה לשמור על שמחה גבוהה בלי לוותר על הרגעים המשפחתיים. יש חשיבות לשירים שהמשפחה מכירה, לברכות ולמעגלים, אבל גם לפתיחה נכונה של הרחבה.',
          'ההבדל בין ערב זורם לערב מקוטע נמצא במעברים: כמה זמן נשארים בטקס, מתי מכניסים שיר שמח, ומתי נותנים לקהל הצעיר להיכנס לתמונה.',
          'אני מתכנן את החלק התוניסאי כך שהוא יהיה מורגש וברור, אבל לא ירגיש כמו בלוק ארוך שמנתק את שאר האורחים.',
        ],
        workBullets: [
          'בחירת שירים תוניסאיים שהמשפחה באמת מחוברת אליהם.',
          'תכנון כניסה, ברכות וטקס לפי הסדר המשפחתי.',
          'שילוב מקצבים תוניסאיים עם מזרחית ולהיטים עכשוויים.',
          'שמירה על מעברים קצרים כדי שהאנרגיה לא תרד.',
          'התאמת המוזיקה לצעירים ולמבוגרים באותו ערב.',
        ],
      },
      henna_yemenite: {
        title: 'חינה תימנית',
        sectionTitle: 'תכנון חינה תימנית עם מוזיקה שמחה',
        description: 'חינה תימנית מלאה בקצב, לבוש, שירה ומשפחה. כך נותנים למסורת מקום וממשיכים למסיבה אנרגטית.',
        imageAlt: 'חינה תימנית עם מוזיקה וריקודים',
        intro: 'בחינה תימנית יש חשיבות גדולה לפתיחה, לטקס ולשירים שמחברים את הדורות. תכנון נכון מאפשר לעבור משירים מסורתיים לרחבה עדכנית בלי לאבד את האופי.',
        bullets: ['בחרו שירי כניסה וטקס שמתאימים למשפחה ולמנהגים.', 'תאמו מראש מתי עוברים מהטקס למסיבה.', 'שלבו שירים תימניים עם מזרחית, ישראלי ולהיטים עכשוויים.', 'וודאו שהסאונד מתאים גם לטקס וגם לרחבת ריקודים.'],
        cta: 'אפשר לשמור על החינה תימנית אותנטית ועדיין לבנות רחבה חזקה. זה מתחיל בתכנון מוזיקלי נכון.',
        trustParagraphs: [
          'בחינה תימנית יכולה להיות מאוד מרגשת כשהשירים, הלבוש והמשפחה מקבלים מקום אמיתי. יש בה הרבה אופי, ולכן לא נכון לטשטש אותה בתוך מוזיקה כללית מדי.',
          'אני בודק אילו שירים חשובים לטקס, האם יש שירה משפחתית, מי מוביל את המעגלים, ומתי נכון לעבור לסט רחבה שידבר גם לצעירים.',
          'התכנון צריך לכבד את המסורת אבל לא להישאר תקוע בה. אחרי שהרגע התימני קיבל מקום, אפשר לפתוח רחבה עם מזרחית, ישראלי וקצב עדכני.',
        ],
        workBullets: [
          'בחירת שירי כניסה וטקס לפי מנהגי המשפחה.',
          'תיאום שירה משפחתית, מעגלים ורגעי ברכה.',
          'שילוב תימנית עם מזרחית, ישראלי ולהיטים לקהל צעיר.',
          'בדיקת סאונד לטקס ולרחבה כדי שהכל יישמע ברור.',
          'מעבר הדרגתי מהמסורת למסיבה בלי לאבד את האופי.',
        ],
      },
      henna_indian: {
        title: 'חינה הודית',
        sectionTitle: 'איך מתכננים חינה הודית צבעונית',
        description: 'חינה הודית משלבת צבע, תלבושות, טקסים משפחתיים ומוזיקה שמחה. כך בונים ערב שמכבד את המסורת ונשאר זורם ברחבה.',
        imageAlt: 'חינה הודית צבעונית עם מוזיקה וריקודים',
        intro: 'בחינה הודית יש הרבה מקום לצבע, כניסות, טקס, תלבושות ורגעים משפחתיים. כדי שהערב ירגיש מקצועי ולא עמוס, צריך לחבר בין שירי מסורת, קצב הודי, מזרחית ולהיטים שהקהל הישראלי מכיר.',
        bullets: ['בחרו שירי כניסה וטקס שמתאימים למשפחה ולמנהגים.', 'תאמו מראש את סדר הכניסות, התלבושות ורגעי הברכה.', 'שלבו מקצבים הודיים עם מזרחית, ישראלי ולהיטים עכשוויים.', 'הכינו מעבר ברור מהטקס לרחבה כדי לשמור על אנרגיה גבוהה.'],
        cta: 'חינה הודית טובה צריכה להרגיש צבעונית, משפחתית ומדויקת. נבנה יחד פסקול שמכבד את המסורת ומרים את הרחבה.',
        trustParagraphs: [
          'בחינה הודית בדרך כלל עשירה מאוד בצבע, תלבושות ורגעים מצטלמים. דווקא בגלל זה חשוב שהתכנון יהיה נקי, כדי שהאירוע לא ירגיש כמו הרבה חלקים שלא מתחברים.',
          'המוזיקה צריכה לתת מקום לקצב ההודי ולמשפחה, אבל גם לדעת מתי לפתוח את הרחבה לקהל הישראלי עם מזרחית, פופ, לטינית ולהיטים מוכרים.',
          'אני מתייחס לחינה הודית כמו ערב עם שפה ויזואלית ומוזיקלית ברורה: כניסה מרשימה, טקס מכובד ומסיבה שממשיכה טבעי.',
        ],
        workBullets: [
          'תכנון כניסה צבעונית עם שיר וקצב שמתאימים למשפחה.',
          'סידור תלבושות, ברכות וטקס בלי עומס מיותר.',
          'שילוב מקצבים הודיים עם מוזיקה מוכרת לקהל הישראלי.',
          'תיאום וידאו, תאורה ואטרקציות עם המוזיקה.',
          'מעבר ברור מהטקס לרחבה כדי לשמור על שמחה גבוהה.',
        ],
      },
      henna_iraqi: {
        title: 'חינה עיראקית',
        sectionTitle: 'תכנון מוזיקה לחינה עיראקית',
        description: 'חינה עיראקית מביאה איתה חום משפחתי, מסורת, מעגלים ושירים שמחברים בין הדורות.',
        imageAlt: 'חינה עיראקית עם משפחה ורחבת ריקודים',
        intro: 'בחינה עיראקית חשוב לתת מקום לשירים שמכירים מהבית, לברכות ולמעגלים של המשפחה, אבל גם לבנות המשך טבעי למסיבה. התכנון המוזיקלי צריך לדעת מתי לשמור על אותנטיות ומתי לפתוח את הרחבה לקהל הרחב.',
        bullets: ['אספו מראש שירים עיראקיים ומשפחתיים שחייבים להיכנס.', 'קבעו מתי מתקיימים הכניסה, הטקס, הברכות והמעגלים.', 'שלבו מוזיקה עיראקית ומזרחית עם להיטים שמתאימים לצעירים.', 'שמרו על מעבר קצר ונקי בין הטקס לריקודים.'],
        cta: 'לחינה עיראקית חזקה צריך שילוב נכון בין מסורת, משפחה ורחבה חיה. אשמח לדייק איתכם את הערב מראש.',
        trustParagraphs: [
          'בחינה עיראקית טובה מרגישה חמה ומחוברת לבית. השירים המשפחתיים והמעגלים הם לא “חלק קטן מהערב”, אלא מה שנותן לאירוע את הזהות שלו.',
          'חשוב להבין מראש אילו שירים באמת חשובים למשפחה, מי צפוי לבקש שירים בזמן אמת, ואיך מונעים מצב שבו בקשות עוצרות את הזרימה.',
          'אחרי שהחלק העיראקי מקבל מקום, אפשר לפתוח את הרחבה למזרחית, ישראלי ולהיטים שמתאימים לצעירים בלי שהאירוע ירגיש מנותק מהמסורת.',
        ],
        workBullets: [
          'איסוף שירים עיראקיים ומשפחתיים לפני האירוע.',
          'תכנון כניסה, ברכות, טקס ומעגלים לפי סדר ברור.',
          'שילוב עיראקית עם מזרחית ולהיטים עדכניים.',
          'ניהול בקשות משפחתיות בלי להפוך את הערב למפוזר.',
          'מעבר קצר מהטקס לרחבה כדי לשמור על קצב.',
        ],
      },
      henna_persian: {
        title: 'חינה פרסית',
        sectionTitle: 'איך בונים חינה פרסית עם קצב נכון',
        description: 'חינה פרסית משלבת אלגנטיות, טקס משפחתי ומוזיקה שמחה. כך יוצרים ערב מכובד שגם יודע להפוך למסיבה.',
        imageAlt: 'חינה פרסית אלגנטית עם מוזיקה ושמחה',
        intro: 'בחינה פרסית יש מקום גדול לאווירה, למשפחה ולרגעים מדויקים. כשבונים את המוזיקה נכון, אפשר לתת למסורת הפרסית את הכבוד שלה ועדיין לשמור על רחבה עדכנית ושמחה לכל האורחים.',
        bullets: ['בחרו שירים פרסיים משמעותיים למשפחה ולכניסות.', 'תכננו את רגעי הטקס כך שלא יהיו עצירות ארוכות מדי.', 'שלבו פרסית, מזרחית, ישראלי ולהיטים בינלאומיים לפי הקהל.', 'תאמו עם הדיג׳יי את נקודות השיא ואת המעבר לרחבה.'],
        cta: 'חינה פרסית טובה מרגישה מכובדת, שמחה וזורמת. נבנה אותה כך שכל רגע יקבל את המקום הנכון.',
        trustParagraphs: [
          'בחינה פרסית בדרך כלל צריכה להרגיש מכובדת ואלגנטית, אבל עדיין שמחה. המוזיקה חייבת לשמור על הטעם המשפחתי ולא להפוך מהר מדי למסיבה כללית.',
          'אני בודק אילו שירים פרסיים חשובים למשפחה, האם יש רגעי כניסה מיוחדים, ואיפה נכון להכניס מזרחית, ישראלי או להיטים בינלאומיים.',
          'כשהחלק הפרסי מתוכנן נכון, הוא מוסיף אופי ויוקרה לערב בלי להאט אותו.',
        ],
        workBullets: [
          'בחירת שירים פרסיים למשפחה, כניסות וטקס.',
          'תכנון רגעי ברכה וטקס בלי עצירות ארוכות.',
          'שילוב פרסית עם מזרחית, ישראלי ולהיטים בינלאומיים.',
          'התאמת הווליום והקצב לקהל מבוגר וצעיר.',
          'פתיחת רחבה בצורה מכובדת אבל שמחה.',
        ],
      },
      bar_bat_recording: {
        title: 'הקלטת שירים לבר/בת מצווה',
        sectionTitle: 'הקלטת שיר לבר מצווה או בת מצווה',
        description: 'שיר מוקלט יכול להפוך כניסה, קליפ או רגע משפחתי למרגשים במיוחד. כך מתכננים אותו בלי לחץ ובלי זיופים מביכים.',
        imageAlt: 'מיקרופון והקלטת שיר לבר מצווה או בת מצווה',
        intro: 'הקלטת שיר לבר או בת מצווה יכולה להיות רגע מרגש מאוד, במיוחד כשהטקסט אישי והביצוע מותאם לילד או לילדה. הסוד הוא לא להעמיס, אלא לבחור רעיון פשוט שעובד.',
        bullets: ['בחרו פלייבק מוכר שמתאים לקול ולגיל של החוגגים.', 'כתבו מילים קצרות וברורות, עם סיפור אישי ולא יותר מדי בדיחות פנימיות.', 'השאירו זמן לחזרות ולהקלטה מחדש אם צריך.', 'תאמו עם הדיג׳יי את נקודת ההשמעה באירוע ואת המעבר לשיר הבא.'],
        cta: 'רוצים לשלב שיר מוקלט בכניסה או בקליפ? אפשר לתכנן את זה כך שירגיש מקצועי ומרגש.',
        trustParagraphs: [
          'שיר מוקלט לבר או בת מצווה יכול להיות רגע מקסים, אבל הוא חייב להתאים לילד או לילדה. אם הטקסט ארוך מדי, הביצוע קשה מדי או הרגע באירוע לא נכון, זה עלול להרגיש מביך במקום מרגש.',
          'אני ממליץ לבחור פלייבק מוכר, לכתוב מילים פשוטות וברורות, ולשמור על אורך שמתאים לקהל. ילדים ונוער מאבדים סבלנות מהר, ולכן שיר קצר ומדויק עובד טוב יותר.',
          'חשוב להחליט אם השיר הוא חלק מהכניסה, קליפ, הפתעה מהמשפחה או רגע לפני ברכות. לכל שימוש יש תזמון אחר ומעבר מוזיקלי אחר.',
        ],
        workBullets: [
          'בחירת פלייבק שמתאים לקול, לגיל ולאופי החוגגים.',
          'כתיבת טקסט אישי אבל לא ארוך מדי.',
          'תכנון חזרות והקלטה בלי לחץ של הרגע האחרון.',
          'קביעת נקודת השמעה באירוע: כניסה, קליפ או הפתעה.',
          'מעבר נקי מהשיר המוקלט להמשך הרחבה או הברכות.',
        ],
      },
      bar_bat_entrance: {
        title: 'כניסה לבר/בת מצווה',
        sectionTitle: 'איך מתכננים כניסה לבר או בת מצווה',
        description: 'כניסה טובה נותנת לחוגג או לחוגגת רגע מרכזי בלי להפוך את האירוע למופע מוגזם. כך בונים אותה נכון.',
        imageAlt: 'כניסה מרגשת לבר מצווה או בת מצווה',
        intro: 'כניסה לבר/בת מצווה צריכה להתאים לאופי של הילד או הילדה. יש מי שאוהבים כניסה דרמטית, ויש מי שירגישו טוב יותר עם רגע קליל, קצר ומשמח.',
        bullets: ['בחרו שיר שהחוגג או החוגגת באמת מתחברים אליו.', 'החליטו אם הכניסה תהיה לבד, עם חברים או עם המשפחה.', 'תכננו אורך קצר וברור כדי לשמור על תשומת הלב של הקהל.', 'חברו את הכניסה מיד לרחבה או לברכה כדי שהאירוע ימשיך לזרום.'],
        cta: 'כניסה טובה היא עניין של מינון ותזמון. נבנה אותה כך שתתאים בדיוק לחוגגים.',
        trustParagraphs: [
          'כניסה לבר או בת מצווה צריכה להרים את החוגגים, לא להביך אותם. יש ילדים שאוהבים להיות במרכז עם שיר חזק ורקדנים, ויש ילדים שצריכים כניסה קצרה ומשפחתית יותר.',
          'אני בודק מי נכנס, עם איזה שיר, האם יש חברים, רקדנים, עשן, זיקוקים קרים או אותיות שם, ומה קורה מיד אחרי הכניסה.',
          'הדבר הכי חשוב הוא שהכניסה לא תרגיש ארוכה מדי. רגע חזק של דקה עובד הרבה יותר טוב ממופע שלם שהקהל מאבד בו קשב.',
        ],
        workBullets: [
          'בחירת שיר שהחוגג או החוגגת באמת אוהבים.',
          'החלטה אם הכניסה לבד, עם חברים, רקדנים או משפחה.',
          'תזמון אפקטים כמו עשן, זיקוקים או אותיות שם.',
          'שמירה על כניסה קצרה וברורה שמתאימה לגיל.',
          'חיבור הכניסה לברכה, קליפ או פתיחת רחבה בלי עצירה.',
        ],
      },
      bar_bat_timeline: {
        title: 'תכנון לו״ז בר/בת מצווה',
        sectionTitle: 'איך בונים לו״ז לבר או בת מצווה',
        description: 'לו״ז בר/בת מצווה צריך לתת מקום לכניסה, ברכות, אוכל ורחבה שמתאימה לנוער ולמשפחה.',
        imageAlt: 'תכנון לוח זמנים לבר או בת מצווה',
        intro: 'האתגר בבר/בת מצווה הוא לשמור על הילדים בעניינים בלי לאבד את המשפחה. לו״ז נכון עושה את האיזון.',
        bullets: ['קבעו מתי הכניסה, הברכות, הקליפ והאוכל.', 'השאירו רחבה פעילה מוקדם יחסית בשביל הנוער.', 'תאמו הפעלות או משחקים עם הדיג׳יי.', 'הימנעו מרצף ארוך מדי של נאומים.'],
        cta: 'לו״ז נכון לבר/בת מצווה שומר על אנרגיה ומתאים לכל הגילים.',
        trustParagraphs: [
          'בבר/בת מצווה הקהל מתחלק מהר: הילדים רוצים קצב, ההורים רוצים אירוע מכובד, והמשפחה המבוגרת צריכה להבין מה קורה. לו״ז טוב מחבר בין כולם.',
          'אם מושכים יותר מדי ברכות וקליפים לפני הרחבה, הנוער מאבד עניין. מצד שני, אם פותחים מסיבה מהר מדי, המשפחה מרגישה שלא היה מספיק מקום לרגעים החשובים.',
          'אני בונה את הסדר כך שהכניסה, האוכל, הברכות, המשחקים והריקודים יקבלו מקום, אבל בלי להפוך את הערב לרשימת משימות.',
        ],
        workBullets: [
          'קביעת סדר כניסה, קליפ, ברכות, אוכל ורחבה.',
          'פתיחת רחבה מוקדמת מספיק כדי לשמור את הנוער פעיל.',
          'תיאום משחקים, הפעלות ורגעי הפתעה עם הדיג׳יי.',
          'קיצור נאומים וקטעי תוכן כדי לא לאבד קשב.',
          'שמירה על איזון בין ילדים, הורים ומשפחה מבוגרת.',
        ],
      },
      bar_bat_attractions: {
        title: 'אטרקציות לבר/בת מצווה',
        sectionTitle: 'איך לבחור אטרקציות לבר או בת מצווה',
        description: 'אטרקציות לבר/בת מצווה צריכות להתאים לחוגגים, לחברים ולמשפחה בלי להשתלט על האירוע. הבחירה צריכה להיות צעירה, מצטלמת טוב, בטוחה, וקלה להפעלה בזמן שהרחבה ממשיכה לעבוד.',
        imageAlt: 'אטרקציות לבר או בת מצווה',
        intro: 'בבר או בת מצווה אפשר לשלב עמדות צילום, וידאו AI, רקדנים, משחקי רחבה, בלונים, זוהרים, מתנפחים מעוצבים, אותיות שם, לייזרים, תותחי עשן או כניסה עם זיקוקים קרים. חשוב לבחור אטרקציות שהילדים באמת יתחברו אליהן ולא רק מה שנראה יפה בקטלוג.',
        bullets: ['בחרו אטרקציה שהילד או הילדה באמת אוהבים ושמתאימה לאופי שלהם, בין אם זו כניסה דרמטית, משחק רחבה או וידאו AI מצחיק.', 'בדקו שהיא מתאימה לגיל החברים ולא מביכה את החוגגים מול הכיתה.', 'תאמו זמן הפעלה שלא שובר את הרחבה: עדיף להכניס אטרקציה אחרי כניסה, אחרי אוכל או לפני שיא מוזיקלי.', 'עדיף אטרקציה אחת חזקה או שתיים מדויקות מאשר הרבה דברים מפוזרים שגורמים לילדים לברוח מהרחבה.'],
        cta: 'אטרקציה נכונה הופכת את הבר או בת המצווה לאישי יותר בלי לפגוע בקצב של האירוע.',
        trustParagraphs: [
          'באירועי בר/בת מצווה אטרקציה חייבת לעבור קודם דרך השאלה: האם הילד או הילדה ירגישו עם זה טוב? מה שנראה מרשים להורים יכול לפעמים להביך את החוגגים מול החברים.',
          'אני מעדיף אטרקציות קצרות, מצטלמות וקלות להפעלה: כניסה חזקה, וידאו AI, אותיות שם, משחק רחבה או אפקט שמגיע בדיוק על שיא מוזיקלי.',
          'צריך להיזהר לא להפוך את האירוע להפעלות בלי רחבה. הילדים באים לזוז, לצחוק ולהרגיש חלק, לא לעמוד בתור לכל עמדה.',
        ],
        workBullets: [
          'בחירת אטרקציה שמתאימה לאופי החוגגים ולגיל החברים.',
          'תזמון כניסה, וידאו AI, משחקי רחבה, אותיות או אפקטים.',
          'בדיקה שהאטרקציה לא מביכה ולא ארוכה מדי.',
          'שמירה על רחבה פעילה בלי יותר מדי עצירות.',
          'תיאום בטיחות, מקום וחשמל מול האולם.',
        ],
      },
      bar_bat_musicians: {
        title: 'נגנים לבר/בת מצווה',
        sectionTitle: 'מתי לשלב נגנים בבר או בת מצווה',
        description: 'נגנים לבר/בת מצווה יכולים לשדרג כניסה, קבלת פנים או רגע משפחתי מיוחד.',
        imageAlt: 'נגנים באירוע בר או בת מצווה',
        intro: 'נגנים חיים עובדים טוב במיוחד בכניסה, בקבלת פנים או בהרמת אנרגיה קצרה, כל עוד הם מותאמים לקהל הצעיר.',
        bullets: ['בחרו כלי נגינה שמתאים לאופי האירוע.', 'שלבו נגנים ברגע קצר ומדויק.', 'תאמו מראש עם הדיג׳יי את השירים והסאונד.', 'ודאו שהנגנים לא מחליפים את הרחבה אלא מחזקים אותה.'],
        cta: 'שילוב נגנים נכון מוסיף חגיגיות בלי להפוך את האירוע לכבד.',
        trustParagraphs: [
          'נגנים בבר/בת מצווה צריכים להיות מדויקים מאוד. קהל של ילדים ונוער לא תמיד מתחבר להופעה ארוכה, אבל כן מגיב טוב לרגע קצר שמרים כניסה או פתיחת רחבה.',
          'סקסופון, כנרית, דרבוקות או כלי הקשה יכולים לעבוד יפה, בתנאי שהם משתלבים עם השירים שהילדים מכירים ולא הופכים את האירוע למבוגר מדי.',
          'התפקיד שלי הוא לחבר בין הנגן, הדיג׳יי והקהל כך שהרגע ירגיש חגיגי אבל עדיין צעיר.',
        ],
        workBullets: [
          'בחירת כלי נגינה שמתאים לגיל ולאופי האירוע.',
          'שילוב הנגן בכניסה, קבלת פנים או פתיחת רחבה.',
          'תיאום שירים וסאונד מול הדיג׳יי.',
          'שמירה על קטע קצר כדי לא לאבד את הנוער.',
          'מעבר מהנגן לסט ריקודים בצורה חלקה.',
        ],
      },
      bar_bat_music: {
        title: 'בחירת מוזיקה לבר/בת מצווה',
        sectionTitle: 'איך לבחור מוזיקה לבר או בת מצווה',
        description: 'מוזיקה לבר/בת מצווה צריכה לדבר גם לחברים מהכיתה וגם למשפחה. השילוב הנכון מחזיק את הנוער ברחבה בלי להשאיר את המבוגרים מחוץ לאירוע.',
        imageAlt: 'בחירת מוזיקה לבר מצווה או בת מצווה',
        intro: 'בבר או בת מצווה יש קהל מאוד מגוון: ילדים ונוער שרוצים להיטים, הורים שרוצים מוזיקה נעימה, משפחה מבוגרת שרוצה להרגיש שייכת, ולעיתים גם קהל דתי או מסורתי. לכן לא בוחרים רק “מה שהילדים שומעים”, אלא בונים ערב עם שכבות.',
        bullets: ['שאלו את החוגג או החוגגת איזה זמרים, להקות וסגנונות הם באמת אוהבים: פופ, היפ הופ, מזרחית, לטינית, טראנס, טכנו או שירי טיקטוק שמתאימים לגיל.', 'בדקו מה המשפחה אוהבת לשמוע: נוסטלגיות, ישראלי, להקות, מוזיקה דתית, חסידית או מזרחית שתפתח גם את המבוגרים.', 'שלבו בין להיטים לנוער לבין רגעים משפחתיים: כניסה, ברכות, שיר מוקלט, משחקי רחבה וסט ריקודים שמתאים לכל הגילים.', 'הכינו רשימת שירים שלא רוצים באירוע, במיוחד אם יש מילים לא מתאימות לגיל או לקהל דתי.'],
        cta: 'בחירת מוזיקה לבר/בת מצווה טובה נותנת לילדים להרגיש במרכז, אבל שומרת על אירוע משפחתי שמח ומכבד.',
        trustParagraphs: [
          'בבר/בת מצווה הדיג׳יי צריך לדבר בשתי שפות: השפה של החברים מהכיתה והשפה של המשפחה. אם מנגנים רק להיטים לנוער, המבוגרים יוצאים החוצה. אם מנגנים רק למשפחה, הילדים נעלמים.',
          'אני בודק עם החוגגים מה הם באמת אוהבים, אבל גם מסנן שירים שלא מתאימים לגיל, למילים או לקהל דתי/מסורתי אם יש כזה.',
          'המטרה היא לבנות ערב שבו הילד או הילדה מרגישים במרכז, והמשפחה עדיין מרגישה שזה אירוע מכבד ושמח.',
        ],
        workBullets: [
          'רשימת סגנונות שהחוגגים אוהבים באמת.',
          'בדיקת שירים לא מתאימים מבחינת מילים, גיל או קהל דתי.',
          'שילוב פופ, היפ הופ, מזרחית, לטינית, טראנס, טכנו ונוסטלגיות לפי הקהל.',
          'הכנסת רגעים משפחתיים בין סטים צעירים יותר.',
          'קריאת רחבה שמחזיקה גם ילדים וגם מבוגרים.',
        ],
      },
      event_music: {
        title: 'בחירת מוזיקה לאירוע',
        sectionTitle: 'איך לבחור מוזיקה לאירוע',
        description: 'כל אירוע צריך קו מוזיקלי משלו. כדי לבחור נכון צריך להבין מי הקהל, מה מטרת הערב, איזה סגנונות אוהבים ומה יגרום לאנשים להישאר באווירה.',
        imageAlt: 'דיג׳יי מתכנן מוזיקה לאירוע',
        intro: 'באירוע כללי או עסקי אין תבנית אחת. לפעמים צריך מוזיקת רקע אלגנטית, לפעמים קבלת פנים חמה, ולפעמים מסיבה מלאה. הבחירה מתחילה בשאלה מי מגיע: עובדים, לקוחות, משפחה, צעירים, מבוגרים, קהל דתי או קהל מעורב.',
        bullets: ['הגדירו מראש את סוג הקהל והאווירה הרצויה: יוקרתי, קליל, משפחתי, עסקי, שמח או מסיבתי.', 'רשמו סגנונות שיכולים להתאים: מוזיקה מזרחית, ישראלית, לטינית, היפ הופ, נוסטלגיות, טראנס, טכנו, מוזיקה דתית או פלייליסט בינלאומי.', 'בחרו זמרים ולהקות שאתם מתחברים אליהם, אבל השאירו לדיג׳יי מקום לקרוא את הקהל בזמן אמת.', 'הכינו רשימת שירים שלא תרצו לשמוע כדי לשמור על גבולות ברורים בלי לחסום את הזרימה.'],
        cta: 'בין אם זה אירוע פרטי או עסקי, תכנון מוזיקלי נכון עושה את ההבדל בין רקע נעים לערב שאנשים זוכרים.',
        trustParagraphs: [
          'באירוע כללי אין “נוסחה”. אירוע חברה, יום הולדת, מסיבת עובדים, השקה או אירוע משפחתי קטן צריכים מוזיקה אחרת לגמרי. לכן מתחילים מהמטרה של הערב, לא מהפלייליסט.',
          'אני בודק מי מגיע, כמה הקהל מכיר אחד את השני, האם צריך מוזיקה שתאפשר שיחה, מתי נכון להרים קצב, והאם בכלל מתוכננת רחבה או רק אווירה.',
          'באירועים כאלה חשוב במיוחד לא להגזים. לפעמים מוזיקה מדויקת ברקע עושה עבודה טובה יותר מסט אגרסיבי מדי.',
        ],
        workBullets: [
          'הגדרת סוג האירוע: עסקי, משפחתי, פרטי, השקה או מסיבה.',
          'הבנת גיל הקהל, הקשר בין האורחים ורמת האנרגיה הרצויה.',
          'בחירת סגנונות: מזרחית, ישראלי, לטיני, היפ הופ, נוסטלגיות, טכנו או טראנס.',
          'הפרדה בין מוזיקת רקע, רגעי תוכן ורחבת ריקודים.',
          'רשימת שירים לא רצויים כדי לשמור על גבולות ברורים.',
        ],
      },
      event_entrance: {
        title: 'כניסה לאירוע',
        sectionTitle: 'איך מתכננים כניסה לאירוע',
        description: 'כניסה לאירוע נותנת פתיחה ברורה, חגיגית ומדויקת לאווירה של הערב.',
        imageAlt: 'כניסה חגיגית לאירוע',
        intro: 'גם באירוע כללי, כניסה מתוכננת יכולה לסמן רגע פתיחה, להציג בעלי שמחה או לפתוח את הרחבה.',
        bullets: ['בחרו שיר שמתאים לאופי האירוע.', 'החליטו מי נכנס ומתי.', 'תאמו תאורה, הכרזה ומוזיקה.', 'שמרו על כניסה קצרה שמובילה להמשך טבעי.'],
        cta: 'כניסה טובה יוצרת התחלה ברורה ומכניסה את הקהל לאווירה.',
        trustParagraphs: [
          'כניסה לאירוע כללי צריכה להיות פשוטה וברורה. לפעמים זו כניסה של בעלי שמחה, לפעמים פתיחת ערב חברה, ולפעמים הכרזה שמסמנת שהאירוע עובר מקבלת פנים לתוכן או לרחבה.',
          'אם הכניסה לא מתוכננת, היא יכולה להרגיש כמו הכרזה מקרית. עם שיר נכון, תאורה נכונה ותזמון קצר, היא הופכת לרגע שמסדר את הקהל.',
          'אני בודק מי נכנס, מה נאמר במיקרופון, האם יש לוגו, תאורה או אפקט, ומה קורה מיד אחרי הכניסה.',
        ],
        workBullets: [
          'בחירת שיר פתיחה שמתאים לאופי האירוע.',
          'קביעת מי נכנס, מי מכריז ומה סדר הפעולות.',
          'תיאום תאורה, מיקרופון ואפקטים אם יש.',
          'שמירה על כניסה קצרה ומדויקת.',
          'חיבור הכניסה להמשך טבעי: ברכה, תוכן, אוכל או רחבה.',
        ],
      },
      event_attractions: {
        title: 'אטרקציות לאירוע',
        sectionTitle: 'איך לבחור אטרקציות לאירוע',
        description: 'אטרקציות לאירוע צריכות להתאים לקהל, למקום ולמטרה של הערב. באירוע פרטי או עסקי הן יכולות ליצור רושם, תוכן לצילום ורגעי שיא, אבל רק אם הן מתוזמנות נכון ולא מנתקות את הקהל מהאווירה.',
        imageAlt: 'אטרקציות באירוע פרטי או עסקי',
        intro: 'אפשר לשלב זיקוקים קרים לכניסה, תותחי עשן, לייזרים, אותיות או לוגו מואר, מתנפחים מעוצבים, וידאו AI, עמדות צילום, בלונים מתפוצצים לרגע שיא ואפטר פארטי לפי סגנון מוזיקלי. באירועים מסוימים הדיג׳יי יכול לרדת לרחבה, להחליף אנרגיה וליצור תחושה של מסיבה חיה יותר.',
        bullets: ['התאימו את האטרקציה לקהל: אירוע עסקי צריך רושם נקי ומדויק, אירוע פרטי יכול להרשות לעצמו יותר צבע, הפתעות ורחבה משוחררת.', 'בדקו חשמל, מקום, גובה תקרה, אישורי אולם וזמן הקמה, במיוחד בזיקוקים קרים, עשן, לייזרים ומתנפחים.', 'תאמו תזמון עם הדיג׳יי כדי שהאפקט יגיע על דרופ, כניסה, הכרזה, סלואו או מעבר לאפטר פארטי.', 'ודאו שהאטרקציה תומכת בזרימת האירוע ולא הופכת להפסקה טכנית שמורידה את האנרגיה.'],
        cta: 'אטרקציות טובות מוסיפות ערך כשהן מתוזמנות נכון ומחוברות למוזיקה, לקהל ולמטרה של הערב.',
        trustParagraphs: [
          'באירוע כללי, האטרקציה חייבת להתאים למטרה. באירוע עסקי היא צריכה להיראות נקייה ומקצועית; באירוע פרטי אפשר ללכת על משהו צבעוני ומשוחרר יותר.',
          'אני בודק האם האטרקציה באמת תוסיף לערב או רק תיצור עומס. לייזרים, עשן, וידאו AI, לוגו מואר או אפטר פארטי יכולים לעבוד מצוין, אבל רק כשהם נכנסים בזמן הנכון.',
          'הכי חשוב שהקהל לא ירגיש שעוצרים את האירוע בשביל “להפעיל משהו”. האטרקציה צריכה להרגיש חלק מהמוזיקה ומהרגע.',
        ],
        workBullets: [
          'התאמת האטרקציה לקהל עסקי, פרטי, משפחתי או צעיר.',
          'בדיקת חשמל, גובה, בטיחות, מקום וזמן הקמה.',
          'תזמון אפקטים על כניסה, דרופ, הכרזה או אפטר פארטי.',
          'בחירת אטרקציות שלא חוסמות צילום או רחבה.',
          'שילוב הדיג׳יי ברחבה אם זה מתאים לאופי המסיבה.',
        ],
      },
      event_musicians: {
        title: 'נגנים לאירוע',
        sectionTitle: 'שילוב נגנים באירוע',
        description: 'נגנים לאירוע מוסיפים שכבה חיה לקבלת פנים, לטקס קצר או לרגע שיא.',
        imageAlt: 'נגנים לאירוע עם דיג׳יי',
        intro: 'הרכב קבלת פנים, סקסופון, כנרית או כלי הקשה יכולים לשדרג אירוע כשהם משתלבים עם הדיג׳יי ולא מתחרים בו.',
        bullets: ['בחרו נגנים לפי האווירה הרצויה.', 'תאמו רפרטואר ונקודות כניסה מראש.', 'בדקו סאונד וחיבורים מול המקום.', 'שלבו את הנגנים ברגעים שבהם הם מוסיפים הכי הרבה.'],
        cta: 'שילוב נכון של נגנים נותן לאירוע נוכחות חיה ומרשימה.',
        trustParagraphs: [
          'נגנים באירוע כללי צריכים להתאים לאופי הערב: הרכב לקבלת פנים יכול לתת אלגנטיות, סקסופון יכול להרים רחבה, וכלי הקשה יכולים לפתוח מסיבה. לא כל נגן מתאים לכל אירוע.',
          'אני בודק אם הנגן אמור להיות ברקע, להוביל רגע שיא או להצטרף לסט הדיג׳יי. ההגדרה הזאת קובעת את הרפרטואר, הסאונד והזמן הנכון.',
          'כשהנגנים משתלבים נכון, הם מוסיפים חיים ונוכחות בלי להתחרות במוזיקה המרכזית.',
        ],
        workBullets: [
          'בחירת נגן לפי אווירה: אלגנטי, שמח, עסקי או מסיבתי.',
          'תיאום רפרטואר ונקודות כניסה מראש.',
          'בדיקת חיבורים, מיקרופונים וסאונד מול המקום.',
          'קביעת משך הופעה שמתאים לקהל.',
          'מעבר נקי בין נגינה חיה לסט הדיג׳יי.',
        ],
      },
      event_music_timeline: {
        title: 'תכנון לו״ז לאירוע',
        sectionTitle: 'איך בונים לו״ז לאירוע',
        description: 'לו״ז מסודר עוזר לאירוע לזרום נכון: קבלת פנים, ברכות, שיאים, אוכל ורחבה בלי נפילות אנרגיה.',
        imageAlt: 'תכנון לוח זמנים לאירוע',
        intro: 'גם האירוע הכי יפה יכול להרגיש מפוזר בלי תזמון נכון. כשיש לו״ז ברור, כל ספק יודע מתי להיכנס, והדיג׳יי יכול לשמור על קצב טבעי לאורך הערב.',
        bullets: ['חלקו את האירוע לשלבים: קבלת פנים, פתיחה, תוכן, אוכל וריקודים.', 'הגדירו מראש רגעי שיא כמו כניסה, ברכה, קליפ או הרמת כוסית.', 'השאירו מרווחים קצרים לשינויים בזמן אמת.', 'תאמו את הלו״ז עם האולם, הצלמים, המנחה והדיג׳יי.'],
        cta: 'לו״ז טוב מוריד לחץ ביום האירוע. אפשר לבנות אותו יחד לפי המקום, הקהל, הספקים והתוכן.',
        trustParagraphs: [
          'באירוע כללי הלו״ז הוא מה שמונע בלגן. אם אין סדר ברור, לא יודעים מתי לדבר, מתי להגיש אוכל, מתי להפעיל קליפ ומתי לפתוח רחבה.',
          'אני מתכנן את הלו״ז לפי סוג האירוע: אירוע עסקי צריך דיוק ותוכן מסודר, אירוע פרטי צריך יותר גמישות, ואירוע מסיבתי צריך להגיע מהר יותר לאנרגיה.',
          'הדיג׳יי יכול לעזור מאוד בניהול המעברים, אבל רק אם ברור מראש מה אמור לקרות בכל שלב.',
        ],
        workBullets: [
          'חלוקת הערב לקבלת פנים, פתיחה, תוכן, אוכל וריקודים.',
          'סימון רגעי שיא כמו כניסה, ברכה, קליפ או הרמת כוסית.',
          'השארת מרווחים קטנים לשינויים בלי לפרק את הלו״ז.',
          'תיאום מול אולם, צלמים, מנחה, ספקים ודיג׳יי.',
          'התאמת הקצב לאירוע עסקי, פרטי או מסיבתי.',
        ],
      },
    },
  },


  menu: {
    sections: [
      { id: 'home', label: 'בית' },
      { id: 'story', label: 'הסיפור שלי' },
      { id: 'gallery', label: 'גלריה' },
      { id: 'contact', label: 'דברו איתי' },
      { id: 'info', label: 'מידע נוסף' },
      { id: 'reviews', label: 'ביקורות' },
      { id: 'planning', label: 'ארגון אירוע' },
    ],
  },
    // ─────────────────────────────────────────────────────────────
  // SEO FAQ — Wedding
  // ─────────────────────────────────────────────────────────────

  seo: {
    faq: {
      wedding: [
        {
          q: `מה כולל שירות די ג׳יי לחתונה {city}?`,
          a: `השירות כולל היכרות אישית ובניית פסקול מותאם במיוחד עבורכם, ליווי מקצועי לאורך כל הדרך, קריאת קהל חדה, מיקסים מדוייקים ושילוב סגנונות, סאונד ואנרגיה שמבטיחה חתונה ושמחה מהרגע הראשון ועד השיר האחרון.`,
        },
        {
          q: `כמה עולה די ג׳יי לחתונה {city}?`,
          a: `{city} טווח המחירים נע לרוב בין 4,000 ל־9,000 ₪, בהתאם לגודל החתונה, התאריך והציוד.`,
        },
        {
          q: `איך לבחור די ג׳יי לחתונה {city}?`,
          a: `חשוב לבחור די ג׳יי עם ניסיון מוכח בחתונות, יכולת קריאת קהל גבוהה וחיבור אישי לזוג. מומלץ לבדוק המלצות, לראות סרטונים מאירועים אמיתיים ולהרגיש שיש מי שמבין את הסגנון שלכם ויודע להוביל את הערב בצורה מקצועית.`,
        },
        {
          q: `האם די ג׳יי {city} מספק גם ציוד תאורה?`,
          a: `ברוב האולמות קיימת תאורה בסיסית לרחבת הריקודים. למי שמעוניין, ניתן לשלב תאורת במה ותאורות עיצוב מתקדמות בהתאמה אישית לאופי האירוע. אני עובד עם ספקים מובילים בתחום, עם מגוון רחב של אפשרויות תאורה ועיצובי במה לבחירת הזוג, כאשר המחיר משתנה בהתאם לבחירה.`,
        },
        {
          q: `האם אפשר לשלב נגנים חיים בחתונה {city}?`,
          a: `בוודאי, ניתן לשלב נגנים חיים כמו סקסופוניסט, כנרית, דרבוקן או בוזוקי ליצירת אווירה ייחודית ומרגשת.`,
        },
        {
          q: `כמה זמן מנגן די ג׳יי בחתונה?`,
          a: `משך הנגינה נקבע מראש בהתאם ללוח הזמנים של האירוע ויכול להתחיל מכשעתיים ועד ללא הגבלת זמן, בהתאם לבחירת הזוג ולמהלך האירוע.`,
        },
        {
          q: `האם די ג׳יי מקומי {city} מכיר את האולמות?`,
          a: `ברוב המקרים כן. היכרות עם אולמות וגני אירועים באזור מאפשרת עבודה חלקה מול צוות המקום, התאמה מדויקת של הסאונד והתאורה למבנה האולם והיערכות נכונה ללוח הזמנים של האירוע – מה שתורם לזרימה טובה ולחוויה מקצועית יותר לאורך הערב.`,
        },
        {
          q: `מה כוללות חבילות די ג׳יי לחתונה {city}?`,
          a: `חבילת הבסיס כוללת הגעה עם ציוד הדיג׳יי המקצועי והנגינה לאורך האירוע. מעבר לכך ניתן לשדרג ולבנות חבילה בהתאמה אישית הכוללת עמדות דיג׳יי מעוצבות, אפטר פארטי, חבילות סלואו ופרימיום, אטרקציות מיוחדות, נגנים חיים ותוספות שונות בהתאם לסגנון האירוע ולבחירת הזוג.`,
        },
        {
          q: `האם יש גיבוי לציוד?`,
          a: `כן, די ג׳יי מקצועי תמיד מגיע עם ציוד חלופי ותכנית חירום.`,
        },
        {
          q: `איך בוחרים שירים לחופה?`,
          a: `בחירת שירי החופה נעשית יחד עם הזוג ובהתאמה אישית. בדרך כלל בוחרים שיר לכניסת החתן, שיר לכניסת הכלה ושיר לשבירת הכוס, ולעיתים משלבים גם קטעים מיוחדים נוספים. התהליך נעשה בתיאום מלא ותוך ירידה לפרטים הקטנים כדי ליצור רגע מרגש ומדויק.`,
        },
        {
          q: `כמה זמן מראש צריך לשריין די ג׳יי לחתונה {city}?`,
          a: `לפחות חצי שנה מראש, ובקיץ מומלץ אפילו שנה מראש.`,
        },
        {
          q: `האם יש אפשרות לבחירת פלייליסט מלא?`,
          a: `בוודאי. ניתן להעביר רשימת שירים מלאה, רשימת שירים מועדפים, שירים שלא תרצו שיתנגנו או רק כיוונים כלליים לסגנון המוזיקה.`,
        },
        {
          q: `מה האטרקציות הפופולריות לחתונה {city}?`,
          a: `האטרקציות הפופולריות כוללות זיקוקים קרים, עשן כבד, בלונים מתפוצצים, בועות סבון, תאורת במה, נגנים חיים, קונפטי ועוד.`,
        },
      ],
      henna: [
        {
          q: `מה כולל שירות די ג׳יי לחינה {city}?`,
          a: `השירות כולל היכרות אישית ובניית פסקול מותאם במיוחד עבורכם, ליווי מקצועי לאורך כל הדרך, קריאת קהל חדה, מיקסים מדוייקים ושילוב סגנונות, סאונד ואנרגיה שמבטיחה חינה ושמחה מהרגע הראשון ועד השיר האחרון.`,
        },
        {
          q: `אילו סוגי חינות קיימות?`,
          a: `יש מגוון סגנונות כמו חינה מרוקאית, תימנית, פרסית, טוניסאית ועוד. בפועל אפשר גם לשלב בין סגנונות, בהתאם למשפחה, למסורת ולווייב שאתם רוצים ליצור.`,
        },
        {
          q: `איך מתכננים את הכניסות של הארוס והארוסה בחינה {city}?`,
          a: `מתכננים מראש את סדר הכניסות, השירים לכל כניסה ואת הקצב של המעברים, כדי ליצור רגע מרגש ומרשים. אני מלווה אתכם בתיאום השירים והטיימינג מול המקום והמשפחה לפי מה שמתאים לכם.`,
        },
        {
          q: `האם אפשר לתכנן טקס מריחת חינה בצורה מסודרת?`,
          a: `כן. מתאמים מראש את סדר הטקס, המוזיקה לרגעים המרכזיים והמעבר לרחבה. המטרה היא לשמור על זרימה טובה בין הטקס לבין המסיבה, בלי “נפילות” באנרגיה.`,
        },
        {
          q: `איך משלבים את טקס הענקת הזהב בחינה?`,
          a: `בדרך כלל בוחרים שיר/ים מתאימים, מתזמנים את הרגע מול המשפחה והצלמים, ושומרים על רצף מכבד ומרגש. הכול נקבע מראש לפי אופי המשפחה והטקס שאתם רוצים.`,
        },
        {
          q: `האם אפשר לשלב לבוש מסורתי ותלבושות בחינה {city}?`,
          a: `בוודאי. לרוב מתכננים מראש את החלפות הלבוש והטיימינג שלהן, כדי שזה ישתלב נכון עם הטקס, הכניסות והצילום. מומלץ לתאם גם מול האולם או המפיק כדי שהכול ירוץ חלק.`,
        },
        {
          q: `כמה עולה די ג׳יי לחינה {city}?`,
          a: `בדרך כלל טווח המחירים נע בין 2,500 ל־5,000 ₪, בהתאם לגודל החינה, התאריך, המקום והתוספות שנבחרות.`,
        },
        {
          q: `איך לבחור די ג׳יי לחינה {city}?`,
          a: `חשוב לבחור די ג׳יי שיודע לקרוא קהל, לשלב סגנונות שמתאימים לאופי החינה, ולהוביל ערב בצורה מקצועית. מומלץ לבדוק המלצות, לראות סרטונים מאירועים אמיתיים ולהרגיש שיש חיבור וגישה שמתאימה לכם.`,
        },
        {
          q: `כמה זמן מנגן די ג׳יי בחינה?`,
          a: `משך הנגינה נקבע מראש בהתאם ללוח הזמנים של האירוע ויכול להתחיל מכשעתיים ועד ללא הגבלת זמן, בהתאם לבחירתכם ולמהלך האירוע.`,
        },
        {
          q: `מה כוללות חבילות די ג׳יי לחינה?`,
          a: `חבילת הבסיס כוללת הגעה עם ציוד הדיג׳יי המקצועי והנגינה לאורך האירוע. מעבר לכך ניתן לשדרג בהתאמה אישית: עמדות דיג׳יי מעוצבות, אפטר פארטי, חבילות פרימיום, שילוב נגנים חיים ותוספות שונות לפי הבחירה.`,
        },
        {
          q: `האם אפשר לשלב דרבוקות או נגנים חיים בחינה?`,
          a: `בוודאי. ניתן לשלב נגנים חיים כמו דרבוקות, שופרות, סקסופון, כנרית או בוזוקי – בהתאם לסגנון החינה ולבחירתכם.`,
        },
        {
          q: `מה האטרקציות הפופולריות בחינה {city}?`,
          a: `האטרקציות הפופולריות כוללות זיקוקים קרים, עשן כבד, בלונים מתפוצצים, בועות סבון, אותיות, תאורת לייזר, תאורת במה, נגנים חיים, קונפטי, שופרות, דרבוקות, צלם מגנטים, בר קוקטיילים ועוד.`,
        },
        {
          q: `האם די ג׳יי {city} מספק גם ציוד תאורה?`,
          a: `ברוב האולמות קיימת תאורה בסיסית לרחבה. למי שמעוניין, ניתן לשלב תאורת במה ותאורות עיצוב מתקדמות בהתאמה אישית. אני עובד עם ספקים מובילים בתחום ויש מגוון רחב של אפשרויות — המחיר משתנה בהתאם לבחירה.`,
        },
        {
          q: `איך בונים פלייליסט לחינה?`,
          a: `בונים יחד כיוונים מוזיקליים מראש: שירים שאתם אוהבים, שירים שלא תרצו שיתנגנו והעדפות סגנון. במהלך האירוע המוזיקה מותאמת גם לקהל ולרחבה בזמן אמת כדי לשמור על זרימה ואנרגיה.`,
        },
        {
          q: `האם יש אפשרות לבחירת פלייליסט מלא?`,
          a: `בוודאי. ניתן להעביר רשימת שירים מלאה, רשימת מועדפים, רשימת “לא לשים”, או רק כיוונים כלליים. זה הבסיס לבניית הערב, ובאירוע עצמו אני מתאים את המוזיקה לקהל כדי לשמור על רחבה פעילה.`,
        },
        {
          q: `איך להתאים מוזיקה לקהל מגוון בחינה?`,
          a: `התאמה לקהל מגוון נעשית דרך קריאת קהל בזמן אמת ושילוב נכון בין סגנונות, תקופות וקצבים שונים. המוזיקה נבנית בהדרגה בהתאם לאווירה כדי שכל קבוצות האורחים יתחברו וייהנו.`,
        },
        {
          q: `מה חשוב לבדוק בחוזה מול די ג׳יי?`,
          a: `כדאי לוודא: מה כלול במחיר, שעות עבודה, אפשרות להארכה, תנאי ביטול, מה נדרש מצד המקום (חשמל או עמדה) והאם יש גיבוי לציוד.`,
        },
        {
          q: `האם יש גיבוי לציוד?`,
          a: `כן, די ג׳יי מקצועי מגיע מוכן עם ציוד חלופי ותכנית חירום למקרה הצורך.`,
        },
      ],
      bar_bat: [
        {
          q: `מה כולל שירות די ג׳יי לבר/בת מצווה {city}?`,
          a: `השירות כולל היכרות אישית ובניית פסקול מותאם במיוחד עבורכם, ליווי מקצועי לאורך כל הדרך, קריאת קהל חדה, מיקסים מדוייקים ושילוב סגנונות, סאונד ואנרגיה שמבטיחה בר/בת מצווה ושמחה מהרגע הראשון ועד השיר האחרון.`,
        },
        {
          q: `איך מתכננים כניסה מרשימה לחוגג/ת בבר/בת מצווה {city}?`,
          a: `מתכננים מראש שיר כניסה, טיימינג מדויק והעמדה של הקהל או המשפחה, ולעיתים משלבים גם אפקטים לפי בחירה. המטרה היא ליצור כניסה חזקה שמרימה את האנרגיה ומכניסה את כולם לאווירה.`,
        },
        {
          q: `האם אפשר לשלב ברכה או דרשה בבר/בת מצווה {city}?`,
          a: `כן. מתאמים מראש מתי זה קורה במהלך הערב, דואגים למיקרופון מתאים ולסאונד ברור, ומשלבים את זה בצורה זורמת שלא “עוצרת” את האירוע אלא משתלבת בו נכון.`,
        },
        {
          q: `איך שומרים על רחבה עם ילדים וגם מבוגרים בבר/בת מצווה?`,
          a: `באמצעות ניהול נכון של הסט: חלקים שמכוונים לנוער עם להיטים עדכניים, לצד מקטעים שמתאימים למשפחה. קריאת קהל בזמן אמת מאפשרת לשמור על זרימה ולקחת את הרחבה יחד.`,
        },
        {
          q: `איך מנהלים רחבת נוער כדי שלא תתפזר?`,
          a: `שומרים על רצף מוזיקלי נכון, מעבר חכם בין סגנונות, ועובדים במקצועיות מול האנרגיה של הקהל הצעיר. כשצריך מעלים הילוך, וכשצריך מאזנים כדי שהרחבה תישאר יציבה לאורך זמן.`,
        },
        {
          q: `האם אפשר לשלב משחקים או הפעלות כחלק מהמסיבה?`,
          a: `כן, לפי בחירה. אפשר לשלב מנחה או רקדנים או הפעלות רחבה שיתאימו לסגנון של החוגג או החוגגת ולקהל. חשוב שזה יהיה בטעם טוב ובתיאום מראש כדי לשמור על זרימה ולא להעמיס.`,
        },
        {
          q: `כמה עולה די ג׳יי לבר/בת מצווה {city}?`,
          a: `בדרך כלל טווח המחירים נע בין 2,500 ל־4,500 ₪, בהתאם לגודל האירוע, המקום והתוספות שנבחרות.`,
        },
        {
          q: `איך בוחרים די ג׳יי לבר/בת מצווה {city}?`,
          a: `חשוב לבחור די ג׳יי שיודע לעבוד עם קהל צעיר, לקרוא רחבה בזמן אמת ולשלב בין מוזיקה עדכנית לשירים שמתאימים גם למשפחה ולאורחים.`,
        },
        {
          q: `איך בוחרים שירים לבר/בת מצווה?`,
          a: `החוגג או החוגגת בוחרים שירים אהובים וכיוונים מוזיקליים מראש. במהלך האירוע המוזיקה מותאמת גם לאווירה ברחבה ולקהל כדי לשמור על זרימה ואנרגיה.`,
        },
        {
          q: `כמה זמן מנגן די ג׳יי בבר/בת מצווה?`,
          a: `משך הנגינה נקבע מראש בהתאם ללוח הזמנים של האירוע ויכול להתחיל מכשעתיים ועד ללא הגבלת זמן, בהתאם לבחירה ולמהלך האירוע.`,
        },
        {
          q: `מה כוללות חבילות די ג׳יי לבר/בת מצווה?`,
          a: `חבילת הבסיס כוללת הגעה עם ציוד הדיג׳יי המקצועי והנגינה לאורך האירוע. ניתן לשדרג בהתאמה אישית עם עמדות דיג׳יי מעוצבות, אפטר פארטי, אטרקציות שונות, נגנים חיים ותוספות נוספות לפי הבחירה.`,
        },
        {
          q: `האם אפשר לשלב רקדנים או מנחים בבר/בת מצווה?`,
          a: `בוודאי. ניתן לשלב רקדנים, מנחים או הפעלות רחבה שיוצרות אינטראקציה עם הקהל ומגבירות את האנרגיה במהלך האירוע.`,
        },
        {
          q: `מה האטרקציות הפופולריות לבר/בת מצווה {city}?`,
          a: `האטרקציות הפופולריות כוללות זיקוקים קרים, עשן כבד, בלונים מתפוצצים, בועות סבון, אותיות, תאורת לייזר, תאורת במה, נגנים חיים, קונפטי, צלם מגנטים, בר קוקטיילים ועוד.`,
        },
        {
          q: `האם די ג׳יי {city} מספק גם ציוד תאורה?`,
          a: `ברוב האולמות קיימת תאורה בסיסית לרחבה. ניתן לשדרג לתאורת במה ועיצוב תאורה מתקדם בהתאמה אישית, בשיתוף ספקים מובילים בתחום ובהתאם לבחירה.`,
        },
        {
          q: `איך מתאימים מוזיקה לקהל מגוון בבר/בת מצווה?`,
          a: `התאמת מוזיקה לקהל מגוון נעשית באמצעות קריאת קהל בזמן אמת ושילוב נכון בין להיטים עדכניים, שירים אהובים על בני הנוער ומוזיקה שמתאימה גם למשפחה ולאורחים.`,
        },
        {
          q: `האם יש אפשרות לבחירת פלייליסט מלא?`,
          a: `בוודאי. ניתן להעביר רשימת שירים מלאה, רשימת מועדפים, רשימת לא לשים או רק כיוונים כלליים. הפלייליסט משמש בסיס, ובאירוע עצמו המוזיקה מותאמת לרחבה ולקהל.`,
        },
        {
          q: `מה חשוב לבדוק בחוזה מול די ג׳יי?`,
          a: `כדאי לוודא מה כלול במחיר, שעות עבודה, אפשרות להארכה, תנאי ביטול, דרישות טכניות מהמקום והאם יש גיבוי לציוד.`,
        },
        {
          q: `האם יש גיבוי לציוד?`,
          a: `כן, די ג׳יי מקצועי מגיע עם ציוד חלופי ותכנית חירום למקרה הצורך.`,
        },
        {
          q: `כמה זמן מראש כדאי להזמין די ג׳יי לבר/בת מצווה?`,
          a: `מומלץ לשריין לפחות 3–6 חודשים מראש, ובתאריכים מבוקשים אפילו מוקדם יותר.`,
        },
        {
          q: `האם אפשר לשלב וידאו או מצגת בבר/בת מצווה?`,
          a: `כן, ניתן לשלב מסכים להצגת קליפים, מצגות ותמונות אישיות במהלך האירוע וכן לשלב קטעי סאונד ווידאו כחלק מהשואו.`,
        },
      ],
      event: [
        {
          q: `מה כולל שירות די ג׳יי לאירוע חברה או פרטי {city}?`,
          a: `השירות כולל היכרות אישית ובניית פסקול מותאם במיוחד עבורכם, ליווי מקצועי לאורך כל הדרך, קריאת קהל חדה, מיקסים מדוייקים ושילוב סגנונות, סאונד ואנרגיה שמבטיחה אירוע ושמחה מהרגע הראשון ועד השיר האחרון.`,
        },
        {
          q: `כמה עולה די ג׳יי לאירוע {city}?`,
          a: `בדרך כלל טווח המחירים נע בין 2,000 ל־5,000 ₪, בהתאם לסוג האירוע, גודל האירוע, המקום והתוספות שנבחרות.`,
        },
        {
          q: `איך בוחרים די ג׳יי לאירוע?`,
          a: `חשוב לבחור די ג׳יי עם ניסיון, יכולת קריאת קהל, המלצות מאירועים אמיתיים וחיבור לסגנון המוזיקלי שמתאים לאופי האירוע.`,
        },
        {
          q: `כמה זמן מנגן די ג׳יי באירוע?`,
          a: `משך הנגינה נקבע מראש בהתאם ללוח הזמנים של האירוע ויכול להתחיל מכשעתיים ועד ללא הגבלת זמן, בהתאם לבחירה ולמהלך האירוע.`,
        },
        {
          q: `מה כוללות חבילות די ג׳יי לאירועים?`,
          a: `חבילת הבסיס כוללת הגעה עם ציוד הדיג׳יי המקצועי והנגינה לאורך האירוע. ניתן לשדרג בהתאמה אישית עם עמדות דיג׳יי מעוצבות, אפטר פארטי, אטרקציות שונות, נגנים חיים ותוספות נוספות לפי הבחירה.`,
        },
        {
          q: `האם די ג׳יי מתאים גם לאירועים קטנים?`,
          a: `כן, השירות מותאם גם לאירועים מצומצמים וגם לאירועים גדולים, בהתאם לאופי האירוע ולמקום.`,
        },
        {
          q: `האם די ג׳יי {city} מספק גם ציוד תאורה?`,
          a: `ברוב המקומות קיימת תאורה בסיסית לרחבה. ניתן לשדרג לתאורת במה ועיצוב תאורה מתקדם בהתאמה אישית, בשיתוף ספקים מובילים ובהתאם לבחירה.`,
        },
        {
          q: `מה האטרקציות הפופולריות לאירועים {city}?`,
          a: `האטרקציות הפופולריות כוללות זיקוקים קרים, עשן כבד, בלונים מתפוצצים, בועות סבון, אותיות, תאורת לייזר, תאורת במה, נגנים חיים, קונפטי, שופרות, דרבוקות, צלם מגנטים, בר קוקטיילים ועוד.`,
        },
        {
          q: `האם ניתן לקיים אירוע בשטח פתוח או בלוקיישן מיוחד?`,
          a: `כן, ניתן לקיים אירועים בשטח פתוח, חוף, גן או לוקיישן מיוחד. אירועים מסוג זה דורשים התאמה של מערכות סאונד, תאורה וציוד נוסף בהתאם למקום ולתנאי השטח.`,
        },
        {
          q: `איך מתאימים מוזיקה לקהל מגוון באירוע?`,
          a: `התאמת מוזיקה לקהל מגוון נעשית באמצעות קריאת קהל בזמן אמת ושילוב נכון בין סגנונות, תקופות וקצבים שונים כדי ליצור חיבור בין האורחים ולשמור על רחבה פעילה.`,
        },
        {
          q: `האם יש אפשרות לבחירת פלייליסט מלא?`,
          a: `בוודאי. ניתן להעביר רשימת שירים מלאה, רשימת מועדפים, רשימת לא לשים או רק כיוונים כלליים. הפלייליסט משמש בסיס, ובאירוע עצמו המוזיקה מותאמת לרחבה ולקהל.`,
        },
        {
          q: `האם אפשר לשלב נגנים חיים או מופע לייב?`,
          a: `כן, ניתן לשלב נגנים חיים כמו סקסופון, כנרית, דרבוקות, בוזוקי ונגנים נוספים בהתאם לסגנון האירוע ולבחירה האישית.`,
        },
        {
          q: `כמה זמן מראש כדאי לשריין די ג׳יי?`,
          a: `מומלץ לשריין לפחות 3–6 חודשים מראש, ובתאריכים מבוקשים אף מוקדם יותר.`,
        },
        {
          q: `מה חשוב לבדוק בחוזה מול די ג׳יי?`,
          a: `כדאי לוודא מה כלול במחיר, שעות עבודה, אפשרות להארכה, תנאי ביטול, דרישות טכניות מהמקום והאם יש גיבוי לציוד.`,
        },
        {
          q: `האם יש גיבוי לציוד?`,
          a: `כן, די ג׳יי מקצועי מגיע עם ציוד חלופי ותכנית חירום למקרה הצורך.`,
        },
        {
          q: `האם אפשר לשלב וידאו או מצגת באירוע?`,
          a: `כן, ניתן לשלב מסכים להצגת קליפים, מצגות ותמונות אישיות במהלך האירוע וכן לשלב קטעי סאונד ווידאו כחלק מהשואו.`,
        },
      ],
      homeEvent: [
        {
          q: `מה כולל שירות די ג׳יי לאירוע?`,
          a: `השירות כולל היכרות אישית ובניית פסקול מותאם במיוחד עבורכם, ליווי מקצועי לאורך כל הדרך, קריאת קהל חדה, מיקסים מדוייקים ושילוב סגנונות, סאונד ואנרגיה שמבטיחה אירוע ושמחה מהרגע הראשון ועד השיר האחרון.`,
        },
        {
          q: `כמה עולה די ג׳יי לאירוע?`,
          a: `בדרך כלל טווח המחירים נע בין 2,000 ל־5,000 ₪, בהתאם לסוג האירוע, גודל האירוע, המיקום והתוספות שנבחרות.`,
        },
        {
          q: `לאילו סוגי אירועים אתה מתאים כדיג׳יי?`,
          a: `אני מתאים לחתונות, חינות, בר ובת מצווה, אירועי חברה, מסיבות עובדים, ימי גיבוש, מסיבות פרטיות ואירועים משפחתיים.`,
        },
        {
          q: `איך אתה מתאים מוזיקה לאירועים לקהל?`,
          a: `אני קורא את הרחבה בזמן אמת ומשלב בין סגנונות, תקופות וקצבים שונים בהתאם לאווירה ולקהל, כדי לשמור על רחבה פעילה לאורך כל האירוע.`,
        },
        {
          q: `האם יש לך ציוד דיג׳יי והגברה משלך?`,
          a: `כן. אני מגיע עם ציוד דיג׳יי מקצועי והגברה הכוללת רמקולים, מיקסר ומיקרופונים, בהתאם לצרכי המקום ולגודל האירוע.`,
        },
        {
          q: `האם אפשר לשלב גם תאורה באירוע?`,
          a: `ברוב המקומות קיימת תאורה בסיסית לרחבה. למי שמעוניין, ניתן לשדרג לתאורת במה ועיצוב תאורה מתקדם בהתאמה אישית ובשיתוף ספקים מובילים, בהתאם לבחירה.`,
        },
        {
          q: `כמה זמן מראש כדאי לסגור די ג׳יי?`,
          a: `מומלץ לשריין כמה חודשים מראש, ובתאריכים מבוקשים או בעונות עמוסות אפילו מוקדם יותר כדי להבטיח זמינות.`,
        },
        {
          q: `האם די ג׳יי מתאים גם לאירועים קטנים ואינטימיים?`,
          a: `בהחלט. אני מתאים את עוצמת הסאונד, סגנון המוזיקה והאווירה גם לאירועים קטנים כמו מסיבות בית, גג, ימי הולדת ואירועים משפחתיים מצומצמים.`,
        },
        {
          q: `איך בוחרים די ג׳יי לאירוע?`,
          a: `מומלץ לבדוק ניסיון, המלצות מאירועים אמיתיים, סרטונים, סגנון מוזיקלי שמתאים לכם וכמובן חיבור אישי בשיחה או פגישה.`,
        },
        {
          q: `מה כוללות החבילות והאפשרויות לשדרוג?`,
          a: `חבילת הבסיס כוללת הגעה עם ציוד הדיג׳יי והנגינה לאורך האירוע. ניתן לשדרג בהתאמה אישית עם עמדות דיג׳יי מעוצבות, אפטר פארטי, אטרקציות שונות, נגנים חיים ותוספות נוספות לפי הבחירה.`,
        },
        {
          q: `מה האטרקציות הפופולריות באירועים?`,
          a: `האטרקציות הפופולריות כוללות זיקוקים קרים, עשן כבד, בלונים מתפוצצים, בועות סבון, אותיות, תאורת לייזר, תאורת במה, נגנים חיים, קונפטי, שופרות, דרבוקות, צלם מגנטים, בר קוקטיילים ועוד.`,
        },
        {
          q: `האם יש גיבוי לציוד במקרה של תקלה?`,
          a: `כן. די ג׳יי מקצועי מגיע עם ציוד חלופי ותכנית חירום למקרה הצורך.`,
        },
        {
          q: `האם אתה מנגן גם באירועי חברה וימי גיבוש?`,
          a: `כן, אני מנגן באירועי חברה, השקות, מסיבות עובדים וימי גיבוש ומתאים את המוזיקה לאופי הארגון והקהל.`,
        },
        {
          q: `איך בונים פלייליסט לאירוע?`,
          a: `בונים יחד כיוונים מוזיקליים, רשימת שירים חשובים ורשימת שירים שפחות מתאימים – ומשם אני בונה סט דינמי שמתאים לזרימה של הערב.`,
        },
        {
          q: `האם אפשר לשלוח רשימת שירים מראש?`,
          a: `בוודאי. ניתן לשלוח רשימת שירים אהובים, שירים שחייבים להתנגן ושירים שפחות מתאימים – ואני משלב אותם בצורה חכמה לאורך האירוע.`,
        },
        {
          q: `מה קורה אם האירוע מתארך?`,
          a: `אפשר להאריך את זמן הנגינה מעבר למה שסוכם מראש, בתיאום במקום ובתוספת תשלום לפי שעה.`,
        },
        {
          q: `האם מתקיים תיאום לפני האירוע?`,
          a: `כן, מומלץ לקיים שיחה או פגישה לפני האירוע כדי לעבור על לוח הזמנים, סגנונות המוזיקה, רגעי השיא ושירים חשובים עבורכם.`,
        },
      ],
    },
  },

// בתוך he
  // ─────────────────────────────────────────────────────────────
  // GEO — Regions & Cities (UI labels only)
  // ─────────────────────────────────────────────────────────────
  geo: {
    regions: {
      דרום: 'דרום',
      מרכז: 'מרכז',
    },

    cities: {
      'באר שבע': 'באר שבע',
      'אשקלון': 'אשקלון',
      'אשדוד': 'אשדוד',
      'קריית גת': 'קריית גת',
      'אופקים': 'אופקים',
      'נתיבות': 'נתיבות',
      'שדרות': 'שדרות',
      'להבים': 'להבים',
      'עומר': 'עומר',
      'דימונה': 'דימונה',
      'קריית מלאכי': 'קריית מלאכי',
      'ערד': 'ערד',
      'ירוחם': 'ירוחם',
      'מיתר': 'מיתר',
      'אילת': 'אילת',
      'קריית עקרון': 'קריית עקרון',
      'גן יבנה': 'גן יבנה',

      'תל אביב': 'תל אביב',
      'רמת גן': 'רמת גן',
      'גבעתיים': 'גבעתיים',
      'ראשון לציון': 'ראשון לציון',
      'חולון': 'חולון',
      'בת ים': 'בת ים',
      'רעננה': 'רעננה',
      'הרצליה': 'הרצליה',
      'פתח תקווה': 'פתח תקווה',
      'יבנה': 'יבנה',
      'רחובות': 'רחובות',
      'נס ציונה': 'נס ציונה',
      'כפר סבא': 'כפר סבא',
      'הוד השרון': 'הוד השרון',
      'מודיעין': 'מודיעין',
      'ראש העין': 'ראש העין',
      'נתניה': 'נתניה',
      'חדרה': 'חדרה',
      'עמק חפר': 'עמק חפר',
    },

    globalLabel: 'כל הארץ',
  },

} as const;

export type HePack = typeof he;
